<template>
  <div>
    <el-dialog class="kpiRule" :title="title" :visible.sync="visible" width="80%" @close="cancel()">
      <el-form :model="data" ref="subKpiRuleRef" :disabled='viewDisabled === "true"'>
        <div>
          <span class="conditionLabel">起奖设定</span>
          <el-form-item class="conditionSelect" prop='premiseConditionKpi'>
            <el-select v-model="data.premiseConditionKpi" clearable placeholder="Select">
              <el-option v-for="(v, i) in selectKpiList" :key="i" :label="v.label" :value="v.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="conditionSelect w100" prop='premiseConditionOperator'>
            <el-select v-model="data.premiseConditionOperator" clearable placeholder="Select">
              <el-option label=">" value=">"></el-option>
              <el-option label=">=" value=">="></el-option>
              <el-option label="<" value="<"></el-option>
              <el-option label="<=" value="<="></el-option>
              <el-option label="=" value="="></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="conditionInput" prop='premiseConditionValue'>
            <el-input v-model="data.premiseConditionValue" @change="tips1"></el-input>
          </el-form-item>
        </div>
        <div>
          <el-form-item class="conditionSelect w100" prop='connector0'>
            <el-select v-model="data.connector0" clearable placeholder="Select">
              <el-option label="AND" value="AND"></el-option>
              <el-option label="OR" value="OR"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="conditionSelect" prop='premiseConditionKpi1'>
            <el-select v-model="data.premiseConditionKpi1" clearable placeholder="Select">
              <el-option v-for="(v, i) in selectKpiList" :key="i" :label="v.label" :value="v.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="conditionSelect w100" prop='premiseConditionOperator1'>
            <el-select v-model="data.premiseConditionOperator1" clearable placeholder="Select">
              <el-option label=">" value=">"></el-option>
              <el-option label=">=" value=">="></el-option>
              <el-option label="<" value="<"></el-option>
              <el-option label="<=" value="<="></el-option>
              <el-option label="=" value="="></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="conditionInput" prop='premiseConditionValue1'>
            <el-input v-model="data.premiseConditionValue1" @change="tips2"></el-input>
          </el-form-item>
        </div>
        <el-divider></el-divider>
        <div label="" v-for="(item, index) in data.conditions" :key="index">
          <span class="conditionLabel" v-if="index == 0">if</span>
          <el-form-item class="conditionSelect w100" v-if="index > 0" :prop='"conditions."+index+".connector"'>
            <el-select v-model="data.conditions[index].connector" clearable placeholder="Select">
              <el-option label="AND" value="AND"></el-option>
              <el-option label="OR" value="OR"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="conditionSelect" :prop='"conditions."+index+".conditionKpi"'>
            <el-select v-model="data.conditions[index].conditionKpi" clearable placeholder="Select">
              <el-option v-for="(v, i) in selectKpiList" :key="i" :label="v.label" :value="v.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="conditionSelect w100" :prop='"conditions."+index+".conditionOperator"'>
            <el-select v-model="data.conditions[index].conditionOperator" clearable placeholder="Select">
              <el-option label=">" value=">"></el-option>
              <el-option label=">=" value=">="></el-option>
              <el-option label="<" value="<"></el-option>
              <el-option label="<=" value="<="></el-option>
              <el-option label="=" value="="></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="conditionInput" :prop='"conditions."+index+".conditionValue"'>
            <el-input v-model="data.conditions[index].conditionValue" @change="tips3"></el-input>
          </el-form-item>
          <el-button type="button" v-if="index == 0" @click="addConditionList(data.conditions)">添 加</el-button>
          <el-button v-if="index > 0" type="button" @click="deleteConditionList(data.conditions, index)">删 除</el-button>
        </div>
        <!-- <el-divider></el-divider> -->
        <el-form-item label="">
          <div class="conditionTitle">then</div>
          <el-form-item prop="thenValue2" label="">
            <span class="conditionLabel">系数 = </span>
            <el-radio-group v-model="data.selectedThenValue" @change="changeSelectedThenValue">
              <el-radio label="1">
                <el-select v-model="data.thenValue1" placeholder="Select" @change="thenValue1Change" @clear='clearValue1' :disabled='data.thenValueDisabled==="true"' clearable>
                  <el-option v-for="(items, index) in thenValueList" :key="index" :label="items.label" :value="items.value"></el-option>
                </el-select>
              </el-radio>
              <el-radio label="2">
                <el-input v-model="data.thenValue2" placeholder="请输入系数" :disabled='data.thenValueDisabled==="false"'></el-input>
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form-item>
        <!-- <el-divider></el-divider> -->
        <el-form-item label="">
          <div class="conditionTitle">else</div>
          <el-form-item label="">
            <span class="conditionLabel">系数 = </span>
            <el-radio-group v-model="data.selectedEndValue" @change="changeSelectedEndValue">
              <el-radio label="3">
                <el-select v-model="data.endValue1" placeholder="Select" @change="endValue1Change" @clear='clearValue1' :disabled='data.endValueDisabled==="true"' clearable>
                  <el-option v-for="(items, index) in endValueList" :key="index" :label="items.label" :value="items.value"></el-option>
                </el-select>
              </el-radio>
              <el-radio label="4">
                <el-input v-model="data.endValue2" placeholder="请输入系数" :disabled='data.endValueDisabled==="false"'></el-input>
              </el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel()">取 消</el-button>
        <el-button type="primary" @click="confirm()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'kpiRule',
  props: {
    kpiConfigList: Array
  },
  data () {
    return {
      visible: false,
      title: '',
      type: '',
      selectKpiList: [],
      thenValueList: [{
        label: '系数1',
        value: '系数1'
      },
      {
        label: '系数2',
        value: '系数2'
      }],
      endValueList: [{
        label: '系数1',
        value: '系数1'
      },
      {
        label: '系数2',
        value: '系数2'
      }],
      data: {
        premiseConditionKpi: '',
        premiseConditionOperator: '',
        premiseConditionValue: '',
        connector0: '',
        premiseConditionKpi1: '',
        premiseConditionOperator1: '',
        premiseConditionValue1: '',
        conditions: [
          {
            connector: '',
            conditionKpi: '',
            conditionOperator: '',
            conditionValue: ''
          }
        ],
        selectedThenValue: '1',
        thenValueDisabled: 'false',
        thenValue1: '',
        thenValue2: '',
        selectedEndValue: '3',
        endValueDisabled: 'false',
        endValue1: '',
        endValue2: ''
      },
      dataCopy: {
        premiseConditionKpi: '',
        premiseConditionOperator: '',
        premiseConditionValue: '',
        connector0: '',
        premiseConditionKpi1: '',
        premiseConditionOperator1: '',
        premiseConditionValue1: '',
        conditions: [
          {
            connector: '',
            conditionKpi: '',
            conditionOperator: '',
            conditionValue: ''
          }
        ],
        selectedThenValue: '1',
        thenValueDisabled: 'false',
        thenValue1: '',
        thenValue2: '',
        selectedEndValue: '3',
        endValueDisabled: 'false',
        endValue1: '',
        endValue2: ''
      },
      row: '',
      viewDisabled: 'false',
      backValueFlag: 'false' // 没用到
    }
  },
  methods: {
    // 改变-新增/修改/删除/查看
    change (type, kpiConfigList, row) {
      this.visible = true
      // console.log(kpiConfigList)
      // console.log(row)
      // console.log(row.kpiAchCondition)
      this.row = row
      switch (type) {
        case 'add':
          this.title = '添加'
          this.type = 'add'
          // 查询对应KPI
          this.kpiQueryByChannelId(row)
          // 清除ThenValue1/EndValue1
          this.clearValue1()
          break
        case 'edit':
          // this.backValueFlag = 'true'
          this.title = '编辑'
          this.type = 'update'
          this.kpiQueryByChannelId(row)
          this.clearValue1()
          // 赋值
          this.data = row.kpiAchCondition
          // 没用到
          // if (this.backValueFlag === 'true') {
          //   this.data = row.kpiAchCondition
          // } else {
          //   this.$http.post(this.API.kpiOverviewList, { year: null, channel: null, position: null }).then((res) => {
          //   // console.log(res)
          //     let data = res.data
          //     if (data.code === 200) {
          //       let overViewList = data.data
          //       let kpiAchCondition = overViewList.filter(ele => {
          //         return row.channelId === ele.channelId && row.positionId === ele.positionId && row.year === ele.year && row.quarter === ele.quarter && row.kpiType === ele.kpiType && row.kpi === ele.kpi
          //       })
          //       if (kpiAchCondition[0].kpiAchCondition === null || kpiAchCondition[0].kpiAchCondition === undefined) {
          //       // console.log(kpiAchCondition)
          //       } else {
          //         this.data = kpiAchCondition[0].kpiAchCondition
          //       // console.log(this.data)
          //       }
          //     } else {
          //       this.$message.error('接口调用失败！')
          //     }
          //   })
          // }
          break
        case 'view':
          this.title = '查看'
          this.type = 'view'
          if (row.kpiAchCondition === undefined || row.kpiAchCondition === null) {
            // row.kpiAchCondition = this.dataTemplate()
            // console.log(this.data)
          } else {
            this.data = row.kpiAchCondition
          }
          this.viewDisabled = 'true'
          break
        case 'delete':
          this.type = 'delete'
          this.visible = false
          this.$confirm('是否删除?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            row.kpiAchCondition = null
            this.data = this.dataTemplate()
            // this.dataCopy = this.dataTemplate()
            this.$message.success('删除成功！')
          }).catch(() => {
            this.$message.warning('已取消删除！')
          })
          break
      }
    },
    // 添加条件
    addConditionList (item) {
      if (this.data.conditions.length < 4) {
        item.push({
          connector: '',
          conditionKpi: '',
          conditionOperator: '',
          conditionValue: ''
        })
      } else {
        this.$message.error('最多只能添加4个条件！')
      }
    },
    // 删除条件
    deleteConditionList (item, index) {
      item.splice(index, 1)
    },
    // then改变
    changeSelectedThenValue (v) {
      // v-选中的值
      // console.log(v)
      if (v === '1') {
        this.data.thenValueDisabled = 'false'
        this.data.thenValue2 = ''
      } else {
        this.data.thenValueDisabled = 'true'
        this.data.thenValue1 = ''
      }
    },
    // 改变thenValue1值
    thenValue1Change (v) {
      // v-选中的值
      // console.log(v)
      if (v === '系数1') {
        this.endValueList = [{ label: '系数2', value: '系数2' }]
      } else {
        this.endValueList = [{ label: '系数1', value: '系数1' }]
      }
    },
    // 清除thenValue1值
    clearThenValue1 () {
      this.thenValueList = [{
        label: '系数1',
        value: '系数1'
      },
      {
        label: '系数2',
        value: '系数2'
      }]
      this.endValueList = [{
        label: '系数1',
        value: '系数1'
      },
      {
        label: '系数2',
        value: '系数2'
      }]
    },
    // 清除ThenValue1/EndValue1
    clearValue1 () {
      this.thenValueList = [{
        label: '系数1',
        value: '系数1'
      },
      {
        label: '系数2',
        value: '系数2'
      }]
      this.endValueList = [{
        label: '系数1',
        value: '系数1'
      },
      {
        label: '系数2',
        value: '系数2'
      }]
    },
    // end改变
    changeSelectedEndValue (v) {
      // console.log(v)
      if (v === '3') {
        this.data.endValueDisabled = 'false'
      } else {
        this.data.endValueDisabled = 'true'
      }
    },
    // 改变endValue1值
    endValue1Change (v) {
      // v-选中的值
      // console.log(v)
      if (v === '系数1') {
        this.thenValueList = [{ label: '系数2', value: '系数2' }]
      } else {
        this.thenValueList = [{ label: '系数1', value: '系数1' }]
      }
    },
    // 清除endValue1值
    clearEndValue1 () {
      this.thenValueList = [{
        label: '系数1',
        value: '系数1'
      },
      {
        label: '系数2',
        value: '系数2'
      }]
      this.endValueList = [{
        label: '系数1',
        value: '系数1'
      },
      {
        label: '系数2',
        value: '系数2'
      }]
    },
    // 取消
    cancel () {
      this.data = this.dataTemplate()
      this.visible = false
    },
    // 确定
    confirm () {
      if (this.type === 'update') {
        // this.dataCopy = this.data
        let length = this.data.conditions.length
        if (length === 1) {
          if ((this.data.premiseConditionKpi !== '' || this.data.premiseConditionOperator !== '') && this.data.premiseConditionValue === '') {
            // 起奖设定1--KPI和运算符有值判断对应值
            this.$message.warning('请填写起奖设定KPI对应的值！')
          } else if ((this.data.premiseConditionKpi === '' || this.data.premiseConditionOperator === '') && this.data.premiseConditionValue !== '') {
            // 起奖设定1--KPI对应值判断对kpi和运算符
            this.$message.warning('请选择起奖设定KPI或者运算符！')
          } else if (this.data.premiseConditionKpi !== '' && this.data.premiseConditionOperator !== '' && this.data.premiseConditionValue !== '') {
            // 其奖设定1--都有值
            if ((this.data.connector0 !== '' || this.data.premiseConditionKpi1 !== '' || this.data.premiseConditionOperator1 !== '') && this.data.premiseConditionValue1 === '') {
              // 起奖设定2--KPI和运算符有值判断对应值
              this.$message.warning('请填写起奖设定KPI对应的值！')
            } else if ((this.data.connector0 === '' || this.data.premiseConditionKpi1 === '' || this.data.premiseConditionOperator1 === '') && this.data.premiseConditionValue1 !== '') {
              // 起奖设定2--KPI对应值判断对kpi和运算符
              this.$message.warning('请选择起奖设定KPI或者运算符！')
            } else if (this.data.connector0 === '' && this.data.premiseConditionKpi1 === '' && this.data.premiseConditionOperator1 === '' && this.data.premiseConditionValue1 === '') {
              // 起奖设定2--都没值
              // 判断if条件
              if ((this.data.conditions[0].conditionKpi !== '' || this.data.conditions[0].conditionOperator !== '') && this.data.conditions[0].conditionValue === '') {
                // if条件--KPI和运算符有值判断对应值-1
                this.$message.warning('请填写if条件KPI对应的值！')
              } else if ((this.data.conditions[0].conditionKpi === '' || this.data.conditions[0].conditionOperator === '') && this.data.conditions[0].conditionValue !== '') {
                // if条件--KPI对应值判断对kpi和运算符-1
                this.$message.warning('请填写if条件KPI或者运算符！')
              } else if (this.data.conditions[0].conditionKpi !== '' && this.data.conditions[0].conditionOperator !== '' && this.data.conditions[0].conditionValue !== '') {
                // 条件1满足--都有值
                // 判断系数
                if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                  // 系数--都有值
                  this.row.kpiAchCondition = this.data
                  this.visible = false
                } else {
                  this.$message.warning('请选择系数！')
                }
              } else if (this.data.conditions[0].conditionKpi === '' && this.data.conditions[0].conditionOperator === '' && this.data.conditions[0].conditionValue === '') {
                // 条件1满足--都没值
                // 判断系数
                if (this.data.thenValue1 === '' && this.data.thenValue2 === '' && this.data.endValue1 === '' && this.data.endValue2 === '') {
                  // 系数--都没值
                  this.row.kpiAchCondition = this.data
                  this.visible = false
                } else {
                  this.$message.warning('请选择if条件！')
                }
              }
            } else if (this.data.connector0 !== '' && this.data.premiseConditionKpi1 !== '' && this.data.premiseConditionOperator1 !== '' && this.data.premiseConditionValue1 !== '') {
              // 起奖设定2--都有值
              // 判断if条件
              if ((this.data.conditions[0].conditionKpi !== '' || this.data.conditions[0].conditionOperator !== '') && this.data.conditions[0].conditionValue === '') {
                // if条件--KPI和运算符有值判断对应值-1
                this.$message.warning('请填写if条件KPI对应的值！')
              } else if ((this.data.conditions[0].conditionKpi === '' || this.data.conditions[0].conditionOperator === '') && this.data.conditions[0].conditionValue !== '') {
                // if条件--KPI对应值判断对kpi和运算符-1
                this.$message.warning('请填写if条件KPI或者运算符！')
              } else if (this.data.conditions[0].conditionKpi !== '' && this.data.conditions[0].conditionOperator !== '' && this.data.conditions[0].conditionValue !== '') {
                // 条件1满足--都有值
                // 判断系数
                if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                  // 系数--都有值
                  this.row.kpiAchCondition = this.data
                  this.visible = false
                } else {
                  this.$message.warning('请选择系数！')
                }
              } else if (this.data.conditions[0].conditionKpi === '' && this.data.conditions[0].conditionOperator === '' && this.data.conditions[0].conditionValue === '') {
                // 条件1满足--都没值
                // 判断系数
                if (this.data.thenValue1 === '' && this.data.thenValue2 === '' && this.data.endValue1 === '' && this.data.endValue2 === '') {
                  // 系数--都没值
                  this.row.kpiAchCondition = this.data
                  this.visible = false
                } else {
                  this.$message.warning('请选择if条件！')
                }
              }
            }
          } else if (this.data.premiseConditionKpi === '' && this.data.premiseConditionOperator === '' && this.data.premiseConditionValue === '') {
            // 其奖设定1--都没值
            if (this.data.connector0 !== '' || this.data.premiseConditionKpi1 !== '' || this.data.premiseConditionOperator1 !== '' || this.data.premiseConditionValue1 !== '') {
              // 起奖设定2--其中有一个为空
              this.$message.warning('请填写起奖设定前提条件！')
            } else if (this.data.connector0 === '' && this.data.premiseConditionKpi1 === '' && this.data.premiseConditionOperator1 === '' && this.data.premiseConditionValue1 === '') {
              // 起奖设定2--都没值
              // 判断if条件
              if ((this.data.conditions[0].conditionKpi !== '' || this.data.conditions[0].conditionOperator !== '') && this.data.conditions[0].conditionValue === '') {
                // if条件--KPI和运算符有值判断对应值-1
                this.$message.warning('请填写if条件KPI对应的值！')
              } else if ((this.data.conditions[0].conditionKpi === '' || this.data.conditions[0].conditionOperator === '') && this.data.conditions[0].conditionValue !== '') {
                // if条件--KPI对应值判断对kpi和运算符-1
                this.$message.warning('请填写if条件KPI或者运算符！')
              } else if (this.data.conditions[0].conditionKpi !== '' && this.data.conditions[0].conditionOperator !== '' && this.data.conditions[0].conditionValue !== '') {
                // 条件1满足--都有值
                // 判断系数
                if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                  // 系数--都有值
                  this.row.kpiAchCondition = this.data
                  this.visible = false
                } else {
                  this.$message.warning('请选择系数！')
                }
              } else if (this.data.conditions[0].conditionKpi === '' && this.data.conditions[0].conditionOperator === '' && this.data.conditions[0].conditionValue === '') {
                // 条件1满足--都没值
                // 判断系数
                if (this.data.thenValue1 === '' && this.data.thenValue2 === '' && this.data.endValue1 === '' && this.data.endValue2 === '') {
                  // 系数--都没值
                  this.row.kpiAchCondition = this.data
                  this.visible = false
                } else {
                  this.$message.warning('请选择if条件！')
                }
              }
            }
          }
        } else if (length === 2) {
          if ((this.data.premiseConditionKpi !== '' || this.data.premiseConditionOperator !== '') && this.data.premiseConditionValue === '') {
            // 起奖设定1--KPI和运算符有值判断对应值
            this.$message.warning('请填写起奖设定KPI对应的值！')
          } else if ((this.data.premiseConditionKpi === '' || this.data.premiseConditionOperator === '') && this.data.premiseConditionValue !== '') {
            // 起奖设定1--KPI对应值判断对kpi和运算符
            this.$message.warning('请选择起奖设定KPI或者运算符！')
          } else if (this.data.premiseConditionKpi !== '' && this.data.premiseConditionOperator !== '' && this.data.premiseConditionValue !== '') {
            // 其奖设定1--都有值
            if ((this.data.connector0 !== '' || this.data.premiseConditionKpi1 !== '' || this.data.premiseConditionOperator1 !== '') && this.data.premiseConditionValue1 === '') {
              // 起奖设定2--KPI和运算符有值判断对应值
              this.$message.warning('请填写起奖设定KPI对应的值！')
            } else if ((this.data.connector0 === '' || this.data.premiseConditionKpi1 === '' || this.data.premiseConditionOperator1 === '') && this.data.premiseConditionValue1 !== '') {
              // 起奖设定2--KPI对应值判断对kpi和运算符
              this.$message.warning('请选择起奖设定KPI或者运算符！')
            } else if (this.data.connector0 === '' && this.data.premiseConditionKpi1 === '' && this.data.premiseConditionOperator1 === '' && this.data.premiseConditionValue1 === '') {
              // 起奖设定2--都没值
              // 判断if条件
              if ((this.data.conditions[0].conditionKpi !== '' || this.data.conditions[0].conditionOperator !== '') && this.data.conditions[0].conditionValue === '') {
                // if条件--KPI和运算符有值判断对应值-1
                this.$message.warning('请填写if条件KPI对应的值！')
              } else if ((this.data.conditions[0].conditionKpi === '' || this.data.conditions[0].conditionOperator === '') && this.data.conditions[0].conditionValue !== '') {
                // if条件--KPI对应值判断对kpi和运算符-1
                this.$message.warning('请填写if条件KPI或者运算符！')
              } else if (this.data.conditions[0].conditionKpi !== '' && this.data.conditions[0].conditionOperator !== '' && this.data.conditions[0].conditionValue !== '') {
                // 条件1满足--都有值
                if ((this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '') && this.data.conditions[1].conditionValue === '') {
                  // if条件2--KPI和运算符有值判断对应值-2
                  this.$message.warning('请填写if条件KPI对应的值！')
                } else if ((this.data.conditions[1].connector === '' || this.data.conditions[1].conditionKpi === '' || this.data.conditions[1].conditionOperator === '') && this.data.conditions[1].conditionValue !== '') {
                  // if条件2--KPI对应值判断对kpi和运算符-2
                  this.$message.warning('请填写if条件KPI或者运算符！')
                } else if (this.data.conditions[1].connector !== '' && this.data.conditions[1].conditionKpi !== '' && this.data.conditions[1].conditionOperator !== '' && this.data.conditions[1].conditionValue !== '') {
                  // 条件2--都有值
                  // 判断系数
                  if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                  // 系数--都有值
                    this.row.kpiAchCondition = this.data
                    this.visible = false
                  } else {
                    this.$message.warning('请选择系数！')
                  }
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  // 判断系数
                  if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                  // 系数--都有值
                    this.row.kpiAchCondition = this.data
                    this.visible = false
                  } else {
                    this.$message.warning('请选择系数！')
                  }
                }
              } else if (this.data.conditions[0].conditionKpi === '' && this.data.conditions[0].conditionOperator === '' && this.data.conditions[0].conditionValue === '') {
                // 条件1满足--都没值
                if (this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '' || this.data.conditions[1].conditionValue !== '') {
                  // 条件2--其中有一个有值
                  this.$message.warning('请填写if前置条件！')
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  // 判断系数
                  if (this.data.thenValue1 === '' && this.data.thenValue2 === '' && this.data.endValue1 === '' && this.data.endValue2 === '') {
                  // 系数--都没值
                    this.row.kpiAchCondition = this.data
                    this.visible = false
                  } else {
                    this.$message.warning('请选择if条件！')
                  }
                }
              }
            } else if (this.data.connector0 !== '' && this.data.premiseConditionKpi1 !== '' && this.data.premiseConditionOperator1 !== '' && this.data.premiseConditionValue1 !== '') {
              // 起奖设定2--都有值
              // 判断if条件
              if ((this.data.conditions[0].conditionKpi !== '' || this.data.conditions[0].conditionOperator !== '') && this.data.conditions[0].conditionValue === '') {
                // if条件--KPI和运算符有值判断对应值-1
                this.$message.warning('请填写if条件KPI对应的值！')
              } else if ((this.data.conditions[0].conditionKpi === '' || this.data.conditions[0].conditionOperator === '') && this.data.conditions[0].conditionValue !== '') {
                // if条件--KPI对应值判断对kpi和运算符-1
                this.$message.warning('请填写if条件KPI或者运算符！')
              } else if (this.data.conditions[0].conditionKpi !== '' && this.data.conditions[0].conditionOperator !== '' && this.data.conditions[0].conditionValue !== '') {
                // 条件1满足--都有值
                if ((this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '') && this.data.conditions[1].conditionValue === '') {
                  // if条件2--KPI和运算符有值判断对应值-2
                  this.$message.warning('请填写if条件KPI对应的值！')
                } else if ((this.data.conditions[1].connector === '' || this.data.conditions[1].conditionKpi === '' || this.data.conditions[1].conditionOperator === '') && this.data.conditions[1].conditionValue !== '') {
                  // if条件2--KPI对应值判断对kpi和运算符-2
                  this.$message.warning('请填写if条件KPI或者运算符！')
                } else if (this.data.conditions[1].connector !== '' && this.data.conditions[1].conditionKpi !== '' && this.data.conditions[1].conditionOperator !== '' && this.data.conditions[1].conditionValue !== '') {
                  // 条件2--都有值
                  // 判断系数
                  if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                  // 系数--都有值
                    this.row.kpiAchCondition = this.data
                    this.visible = false
                  } else {
                    this.$message.warning('请选择系数！')
                  }
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  // 判断系数
                  if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                  // 系数--都有值
                    this.row.kpiAchCondition = this.data
                    this.visible = false
                  } else {
                    this.$message.warning('请选择系数！')
                  }
                }
              } else if (this.data.conditions[0].conditionKpi === '' && this.data.conditions[0].conditionOperator === '' && this.data.conditions[0].conditionValue === '') {
                // 条件1满足--都没值
                if (this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '' || this.data.conditions[1].conditionValue !== '') {
                  // 条件2--其中有一个有值
                  this.$message.warning('请填写if前置条件！')
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  // 判断系数
                  if (this.data.thenValue1 === '' && this.data.thenValue2 === '' && this.data.endValue1 === '' && this.data.endValue2 === '') {
                  // 系数--都没值
                    this.row.kpiAchCondition = this.data
                    this.visible = false
                  } else {
                    this.$message.warning('请选择if条件！')
                  }
                }
              }
            }
          } else if (this.data.premiseConditionKpi === '' && this.data.premiseConditionOperator === '' && this.data.premiseConditionValue === '') {
            // 其奖设定1--都没值
            if (this.data.connector0 !== '' || this.data.premiseConditionKpi1 !== '' || this.data.premiseConditionOperator1 !== '' || this.data.premiseConditionValue1 !== '') {
              // 起奖设定2--其中有一个为空
              this.$message.warning('请填写起奖设定前提条件！')
            } else if (this.data.connector0 === '' && this.data.premiseConditionKpi1 === '' && this.data.premiseConditionOperator1 === '' && this.data.premiseConditionValue1 === '') {
              // 起奖设定2--都没值
              // 判断if条件
              if ((this.data.conditions[0].conditionKpi !== '' || this.data.conditions[0].conditionOperator !== '') && this.data.conditions[0].conditionValue === '') {
                // if条件--KPI和运算符有值判断对应值-1
                this.$message.warning('请填写if条件KPI对应的值！')
              } else if ((this.data.conditions[0].conditionKpi === '' || this.data.conditions[0].conditionOperator === '') && this.data.conditions[0].conditionValue !== '') {
                // if条件--KPI对应值判断对kpi和运算符-1
                this.$message.warning('请填写if条件KPI或者运算符！')
              } else if (this.data.conditions[0].conditionKpi !== '' && this.data.conditions[0].conditionOperator !== '' && this.data.conditions[0].conditionValue !== '') {
                // 条件1满足--都有值
                if ((this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '') && this.data.conditions[1].conditionValue === '') {
                  // if条件2--KPI和运算符有值判断对应值-2
                  this.$message.warning('请填写if条件KPI对应的值！')
                } else if ((this.data.conditions[1].connector === '' || this.data.conditions[1].conditionKpi === '' || this.data.conditions[1].conditionOperator === '') && this.data.conditions[1].conditionValue !== '') {
                  // if条件2--KPI对应值判断对kpi和运算符-2
                  this.$message.warning('请填写if条件KPI或者运算符！')
                } else if (this.data.conditions[1].connector !== '' && this.data.conditions[1].conditionKpi !== '' && this.data.conditions[1].conditionOperator !== '' && this.data.conditions[1].conditionValue !== '') {
                  // 条件2--都有值
                  // 判断系数
                  if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                  // 系数--都有值
                    this.row.kpiAchCondition = this.data
                    this.visible = false
                  } else {
                    this.$message.warning('请选择系数！')
                  }
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  // 判断系数
                  if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                  // 系数--都有值
                    this.row.kpiAchCondition = this.data
                    this.visible = false
                  } else {
                    this.$message.warning('请选择系数！')
                  }
                }
              } else if (this.data.conditions[0].conditionKpi === '' && this.data.conditions[0].conditionOperator === '' && this.data.conditions[0].conditionValue === '') {
                // 条件1满足--都没值
                if (this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '' || this.data.conditions[1].conditionValue !== '') {
                  // 条件2--其中有一个有值
                  this.$message.warning('请填写if前置条件！')
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  // 判断系数
                  if (this.data.thenValue1 === '' && this.data.thenValue2 === '' && this.data.endValue1 === '' && this.data.endValue2 === '') {
                  // 系数--都没值
                    this.row.kpiAchCondition = this.data
                    this.visible = false
                  } else {
                    this.$message.warning('请选择if条件！')
                  }
                }
              }
            }
          }
        } else if (length === 3) {
          if ((this.data.premiseConditionKpi !== '' || this.data.premiseConditionOperator !== '') && this.data.premiseConditionValue === '') {
            // 起奖设定1--KPI和运算符有值判断对应值
            this.$message.warning('请填写起奖设定KPI对应的值！')
          } else if ((this.data.premiseConditionKpi === '' || this.data.premiseConditionOperator === '') && this.data.premiseConditionValue !== '') {
            // 起奖设定1--KPI对应值判断对kpi和运算符
            this.$message.warning('请选择起奖设定KPI或者运算符！')
          } else if (this.data.premiseConditionKpi !== '' && this.data.premiseConditionOperator !== '' && this.data.premiseConditionValue !== '') {
            // 其奖设定1--都有值
            if ((this.data.connector0 !== '' || this.data.premiseConditionKpi1 !== '' || this.data.premiseConditionOperator1 !== '') && this.data.premiseConditionValue1 === '') {
              // 起奖设定2--KPI和运算符有值判断对应值
              this.$message.warning('请填写起奖设定KPI对应的值！')
            } else if ((this.data.connector0 === '' || this.data.premiseConditionKpi1 === '' || this.data.premiseConditionOperator1 === '') && this.data.premiseConditionValue1 !== '') {
              // 起奖设定2--KPI对应值判断对kpi和运算符
              this.$message.warning('请选择起奖设定KPI或者运算符！')
            } else if (this.data.connector0 === '' && this.data.premiseConditionKpi1 === '' && this.data.premiseConditionOperator1 === '' && this.data.premiseConditionValue1 === '') {
              // 起奖设定2--都没值
              // 判断if条件
              if ((this.data.conditions[0].conditionKpi !== '' || this.data.conditions[0].conditionOperator !== '') && this.data.conditions[0].conditionValue === '') {
                // if条件--KPI和运算符有值判断对应值-1
                this.$message.warning('请填写if条件KPI对应的值！')
              } else if ((this.data.conditions[0].conditionKpi === '' || this.data.conditions[0].conditionOperator === '') && this.data.conditions[0].conditionValue !== '') {
                // if条件--KPI对应值判断对kpi和运算符-1
                this.$message.warning('请填写if条件KPI或者运算符！')
              } else if (this.data.conditions[0].conditionKpi !== '' && this.data.conditions[0].conditionOperator !== '' && this.data.conditions[0].conditionValue !== '') {
                // 条件1满足--都有值
                if ((this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '') && this.data.conditions[1].conditionValue === '') {
                  // if条件2--KPI和运算符有值判断对应值-2
                  this.$message.warning('请填写if条件KPI对应的值！')
                } else if ((this.data.conditions[1].connector === '' || this.data.conditions[1].conditionKpi === '' || this.data.conditions[1].conditionOperator === '') && this.data.conditions[1].conditionValue !== '') {
                  // if条件2--KPI对应值判断对kpi和运算符-2
                  this.$message.warning('请填写if条件KPI或者运算符！')
                } else if (this.data.conditions[1].connector !== '' && this.data.conditions[1].conditionKpi !== '' && this.data.conditions[1].conditionOperator !== '' && this.data.conditions[1].conditionValue !== '') {
                  // 条件2--都有值
                  if ((this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '') && this.data.conditions[2].conditionValue === '') {
                  // if条件3--KPI和运算符有值判断对应值-3
                    this.$message.warning('请填写if条件KPI对应的值！')
                  } else if ((this.data.conditions[2].connector === '' || this.data.conditions[2].conditionKpi === '' || this.data.conditions[2].conditionOperator === '') && this.data.conditions[2].conditionValue !== '') {
                  // if条件3--KPI对应值判断对kpi和运算符-3
                    this.$message.warning('请填写if条件KPI或者运算符！')
                  } else if (this.data.conditions[2].connector !== '' && this.data.conditions[2].conditionKpi !== '' && this.data.conditions[2].conditionOperator !== '' && this.data.conditions[2].conditionValue !== '') {
                  // 条件3--都有值
                  // 判断系数
                    if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                      this.row.kpiAchCondition = this.data
                      this.visible = false
                    } else {
                      this.$message.warning('请选择系数！')
                    }
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                  // 条件3--都没值
                  // 判断系数
                    if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                      this.row.kpiAchCondition = this.data
                      this.visible = false
                    } else {
                      this.$message.warning('请选择系数！')
                    }
                  }
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  if (this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '' || this.data.conditions[2].conditionValue !== '') {
                    // 条件3--其中有一个有值
                    this.$message.warning('请填写if前置条件！')
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                    // 条件3--都没值
                    // 判断系数
                    if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                      this.row.kpiAchCondition = this.data
                      this.visible = false
                    } else {
                      this.$message.warning('请选择系数！')
                    }
                  }
                }
              } else if (this.data.conditions[0].conditionKpi === '' && this.data.conditions[0].conditionOperator === '' && this.data.conditions[0].conditionValue === '') {
                // 条件1满足--都没值
                if (this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '' || this.data.conditions[1].conditionValue !== '') {
                  // 条件2--其中有一个有值
                  this.$message.warning('请填写if前置条件！')
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  if (this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '' || this.data.conditions[2].conditionValue !== '') {
                    // 条件3--其中有一个有值
                    this.$message.warning('请填写if前置条件！')
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                    // 条件3--都没值
                    // 判断系数
                    if (this.data.thenValue1 === '' && this.data.thenValue2 === '' && this.data.endValue1 === '' && this.data.endValue2 === '') {
                      // 系数--都没值
                      this.row.kpiAchCondition = this.data
                      this.visible = false
                    } else {
                      this.$message.warning('请选择if条件！')
                    }
                  }
                }
              }
            } else if (this.data.connector0 !== '' && this.data.premiseConditionKpi1 !== '' && this.data.premiseConditionOperator1 !== '' && this.data.premiseConditionValue1 !== '') {
              // 起奖设定2--都有值
              // 判断if条件
              if ((this.data.conditions[0].conditionKpi !== '' || this.data.conditions[0].conditionOperator !== '') && this.data.conditions[0].conditionValue === '') {
                // if条件--KPI和运算符有值判断对应值-1
                this.$message.warning('请填写if条件KPI对应的值！')
              } else if ((this.data.conditions[0].conditionKpi === '' || this.data.conditions[0].conditionOperator === '') && this.data.conditions[0].conditionValue !== '') {
                // if条件--KPI对应值判断对kpi和运算符-1
                this.$message.warning('请填写if条件KPI或者运算符！')
              } else if (this.data.conditions[0].conditionKpi !== '' && this.data.conditions[0].conditionOperator !== '' && this.data.conditions[0].conditionValue !== '') {
                // 条件1满足--都有值
                if ((this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '') && this.data.conditions[1].conditionValue === '') {
                  // if条件2--KPI和运算符有值判断对应值-2
                  this.$message.warning('请填写if条件KPI对应的值！')
                } else if ((this.data.conditions[1].connector === '' || this.data.conditions[1].conditionKpi === '' || this.data.conditions[1].conditionOperator === '') && this.data.conditions[1].conditionValue !== '') {
                  // if条件2--KPI对应值判断对kpi和运算符-2
                  this.$message.warning('请填写if条件KPI或者运算符！')
                } else if (this.data.conditions[1].connector !== '' && this.data.conditions[1].conditionKpi !== '' && this.data.conditions[1].conditionOperator !== '' && this.data.conditions[1].conditionValue !== '') {
                  // 条件2--都有值
                  if ((this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '') && this.data.conditions[2].conditionValue === '') {
                  // if条件3--KPI和运算符有值判断对应值-3
                    this.$message.warning('请填写if条件KPI对应的值！')
                  } else if ((this.data.conditions[2].connector === '' || this.data.conditions[2].conditionKpi === '' || this.data.conditions[2].conditionOperator === '') && this.data.conditions[2].conditionValue !== '') {
                  // if条件3--KPI对应值判断对kpi和运算符-3
                    this.$message.warning('请填写if条件KPI或者运算符！')
                  } else if (this.data.conditions[2].connector !== '' && this.data.conditions[2].conditionKpi !== '' && this.data.conditions[2].conditionOperator !== '' && this.data.conditions[2].conditionValue !== '') {
                  // 条件3--都有值
                  // 判断系数
                    if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                      this.row.kpiAchCondition = this.data
                      this.visible = false
                    } else {
                      this.$message.warning('请选择系数！')
                    }
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                  // 条件3--都没值
                  // 判断系数
                    if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                      this.row.kpiAchCondition = this.data
                      this.visible = false
                    } else {
                      this.$message.warning('请选择系数！')
                    }
                  }
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  if (this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '' || this.data.conditions[2].conditionValue !== '') {
                    // 条件3--其中有一个有值
                    this.$message.warning('请填写if前置条件！')
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                    // 条件3--都没值
                    // 判断系数
                    if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                      this.row.kpiAchCondition = this.data
                      this.visible = false
                    } else {
                      this.$message.warning('请选择系数！')
                    }
                  }
                }
              } else if (this.data.conditions[0].conditionKpi === '' && this.data.conditions[0].conditionOperator === '' && this.data.conditions[0].conditionValue === '') {
                // 条件1满足--都没值
                if (this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '' || this.data.conditions[1].conditionValue !== '') {
                  // 条件2--其中有一个有值
                  this.$message.warning('请填写if前置条件！')
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  if (this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '' || this.data.conditions[2].conditionValue !== '') {
                    // 条件3--其中有一个有值
                    this.$message.warning('请填写if前置条件！')
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                    // 条件3--都没值
                    // 判断系数
                    if (this.data.thenValue1 === '' && this.data.thenValue2 === '' && this.data.endValue1 === '' && this.data.endValue2 === '') {
                      // 系数--都没值
                      this.row.kpiAchCondition = this.data
                      this.visible = false
                    } else {
                      this.$message.warning('请选择if条件！')
                    }
                  }
                }
              }
            }
          } else if (this.data.premiseConditionKpi === '' && this.data.premiseConditionOperator === '' && this.data.premiseConditionValue === '') {
            // 其奖设定1--都没值
            if (this.data.connector0 !== '' || this.data.premiseConditionKpi1 !== '' || this.data.premiseConditionOperator1 !== '' || this.data.premiseConditionValue1 !== '') {
              // 起奖设定2--其中有一个为空
              this.$message.warning('请填写起奖设定前提条件！')
            } else if (this.data.connector0 === '' && this.data.premiseConditionKpi1 === '' && this.data.premiseConditionOperator1 === '' && this.data.premiseConditionValue1 === '') {
              // 起奖设定2--都没值
              // 判断if条件
              if ((this.data.conditions[0].conditionKpi !== '' || this.data.conditions[0].conditionOperator !== '') && this.data.conditions[0].conditionValue === '') {
                // if条件--KPI和运算符有值判断对应值-1
                this.$message.warning('请填写if条件KPI对应的值！')
              } else if ((this.data.conditions[0].conditionKpi === '' || this.data.conditions[0].conditionOperator === '') && this.data.conditions[0].conditionValue !== '') {
                // if条件--KPI对应值判断对kpi和运算符-1
                this.$message.warning('请填写if条件KPI或者运算符！')
              } else if (this.data.conditions[0].conditionKpi !== '' && this.data.conditions[0].conditionOperator !== '' && this.data.conditions[0].conditionValue !== '') {
                // 条件1满足--都有值
                if ((this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '') && this.data.conditions[1].conditionValue === '') {
                  // if条件2--KPI和运算符有值判断对应值-2
                  this.$message.warning('请填写if条件KPI对应的值！')
                } else if ((this.data.conditions[1].connector === '' || this.data.conditions[1].conditionKpi === '' || this.data.conditions[1].conditionOperator === '') && this.data.conditions[1].conditionValue !== '') {
                  // if条件2--KPI对应值判断对kpi和运算符-2
                  this.$message.warning('请填写if条件KPI或者运算符！')
                } else if (this.data.conditions[1].connector !== '' && this.data.conditions[1].conditionKpi !== '' && this.data.conditions[1].conditionOperator !== '' && this.data.conditions[1].conditionValue !== '') {
                  // 条件2--都有值
                  if ((this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '') && this.data.conditions[2].conditionValue === '') {
                  // if条件3--KPI和运算符有值判断对应值-3
                    this.$message.warning('请填写if条件KPI对应的值！')
                  } else if ((this.data.conditions[2].connector === '' || this.data.conditions[2].conditionKpi === '' || this.data.conditions[2].conditionOperator === '') && this.data.conditions[2].conditionValue !== '') {
                  // if条件3--KPI对应值判断对kpi和运算符-3
                    this.$message.warning('请填写if条件KPI或者运算符！')
                  } else if (this.data.conditions[2].connector !== '' && this.data.conditions[2].conditionKpi !== '' && this.data.conditions[2].conditionOperator !== '' && this.data.conditions[2].conditionValue !== '') {
                  // 条件3--都有值
                  // 判断系数
                    if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                      this.row.kpiAchCondition = this.data
                      this.visible = false
                    } else {
                      this.$message.warning('请选择系数！')
                    }
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                  // 条件3--都没值
                  // 判断系数
                    if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                      this.row.kpiAchCondition = this.data
                      this.visible = false
                    } else {
                      this.$message.warning('请选择系数！')
                    }
                  }
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  if (this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '' || this.data.conditions[2].conditionValue !== '') {
                    // 条件3--其中有一个有值
                    this.$message.warning('请填写if前置条件！')
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                    // 条件3--都没值
                    // 判断系数
                    if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                      this.row.kpiAchCondition = this.data
                      this.visible = false
                    } else {
                      this.$message.warning('请选择系数！')
                    }
                  }
                }
              } else if (this.data.conditions[0].conditionKpi === '' && this.data.conditions[0].conditionOperator === '' && this.data.conditions[0].conditionValue === '') {
                // 条件1满足--都没值
                if (this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '' || this.data.conditions[1].conditionValue !== '') {
                  // 条件2--其中有一个有值
                  this.$message.warning('请填写if前置条件！')
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  if (this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '' || this.data.conditions[2].conditionValue !== '') {
                    // 条件3--其中有一个有值
                    this.$message.warning('请填写if前置条件！')
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                    // 条件3--都没值
                    // 判断系数
                    if (this.data.thenValue1 === '' && this.data.thenValue2 === '' && this.data.endValue1 === '' && this.data.endValue2 === '') {
                      // 系数--都没值
                      this.row.kpiAchCondition = this.data
                      this.visible = false
                    } else {
                      this.$message.warning('请选择if条件！')
                    }
                  }
                }
              }
            }
          }
        } else if (length === 4) {
          if ((this.data.premiseConditionKpi !== '' || this.data.premiseConditionOperator !== '') && this.data.premiseConditionValue === '') {
            // 起奖设定1--KPI和运算符有值判断对应值
            this.$message.warning('请填写起奖设定KPI对应的值！')
          } else if ((this.data.premiseConditionKpi === '' || this.data.premiseConditionOperator === '') && this.data.premiseConditionValue !== '') {
            // 起奖设定1--KPI对应值判断对kpi和运算符
            this.$message.warning('请选择起奖设定KPI或者运算符！')
          } else if (this.data.premiseConditionKpi !== '' && this.data.premiseConditionOperator !== '' && this.data.premiseConditionValue !== '') {
            // 其奖设定1--都有值
            if ((this.data.connector0 !== '' || this.data.premiseConditionKpi1 !== '' || this.data.premiseConditionOperator1 !== '') && this.data.premiseConditionValue1 === '') {
              // 起奖设定2--KPI和运算符有值判断对应值
              this.$message.warning('请填写起奖设定KPI对应的值！')
            } else if ((this.data.connector0 === '' || this.data.premiseConditionKpi1 === '' || this.data.premiseConditionOperator1 === '') && this.data.premiseConditionValue1 !== '') {
              // 起奖设定2--KPI对应值判断对kpi和运算符
              this.$message.warning('请选择起奖设定KPI或者运算符！')
            } else if (this.data.connector0 === '' && this.data.premiseConditionKpi1 === '' && this.data.premiseConditionOperator1 === '' && this.data.premiseConditionValue1 === '') {
              // 起奖设定2--都没值
              // 判断if条件
              if ((this.data.conditions[0].conditionKpi !== '' || this.data.conditions[0].conditionOperator !== '') && this.data.conditions[0].conditionValue === '') {
                // if条件--KPI和运算符有值判断对应值-1
                this.$message.warning('请填写if条件KPI对应的值！')
              } else if ((this.data.conditions[0].conditionKpi === '' || this.data.conditions[0].conditionOperator === '') && this.data.conditions[0].conditionValue !== '') {
                // if条件--KPI对应值判断对kpi和运算符-1
                this.$message.warning('请填写if条件KPI或者运算符！')
              } else if (this.data.conditions[0].conditionKpi !== '' && this.data.conditions[0].conditionOperator !== '' && this.data.conditions[0].conditionValue !== '') {
                // 条件1满足--都有值
                if ((this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '') && this.data.conditions[1].conditionValue === '') {
                  // if条件2--KPI和运算符有值判断对应值-2
                  this.$message.warning('请填写if条件KPI对应的值！')
                } else if ((this.data.conditions[1].connector === '' || this.data.conditions[1].conditionKpi === '' || this.data.conditions[1].conditionOperator === '') && this.data.conditions[1].conditionValue !== '') {
                  // if条件2--KPI对应值判断对kpi和运算符-2
                  this.$message.warning('请填写if条件KPI或者运算符！')
                } else if (this.data.conditions[1].connector !== '' && this.data.conditions[1].conditionKpi !== '' && this.data.conditions[1].conditionOperator !== '' && this.data.conditions[1].conditionValue !== '') {
                  // 条件2--都有值
                  if ((this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '') && this.data.conditions[2].conditionValue === '') {
                  // if条件3--KPI和运算符有值判断对应值-3
                    this.$message.warning('请填写if条件KPI对应的值！')
                  } else if ((this.data.conditions[2].connector === '' || this.data.conditions[2].conditionKpi === '' || this.data.conditions[2].conditionOperator === '') && this.data.conditions[2].conditionValue !== '') {
                  // if条件3--KPI对应值判断对kpi和运算符-3
                    this.$message.warning('请填写if条件KPI或者运算符！')
                  } else if (this.data.conditions[2].connector !== '' && this.data.conditions[2].conditionKpi !== '' && this.data.conditions[2].conditionOperator !== '' && this.data.conditions[2].conditionValue !== '') {
                  // 条件3--都有值

                    if ((this.data.conditions[3].connector !== '' || this.data.conditions[3].conditionKpi !== '' || this.data.conditions[3].conditionOperator !== '') && this.data.conditions[3].conditionValue === '') {
                      // if条件4--KPI和运算符有值判断对应值-4
                      this.$message.warning('请填写if条件KPI对应的值！')
                    } else if ((this.data.conditions[3].connector === '' || this.data.conditions[3].conditionKpi === '' || this.data.conditions[3].conditionOperator === '') && this.data.conditions[3].conditionValue !== '') {
                      // if条件4--KPI对应值判断对kpi和运算符-4
                      this.$message.warning('请填写if条件KPI或者运算符！')
                    } else if (this.data.conditions[3].connector !== '' && this.data.conditions[3].conditionKpi !== '' && this.data.conditions[3].conditionOperator !== '' && this.data.conditions[3].conditionValue !== '') {
                      // 条件4--都有值
                      // 判断系数
                      if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                        this.row.kpiAchCondition = this.data
                        this.visible = false
                      } else {
                        this.$message.warning('请选择系数！')
                      }
                    } else if (this.data.conditions[3].connector === '' && this.data.conditions[3].conditionKpi === '' && this.data.conditions[3].conditionOperator === '' && this.data.conditions[3].conditionValue === '') {
                      // 条件4--都没值
                      // 判断系数
                      if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                        this.row.kpiAchCondition = this.data
                        this.visible = false
                      } else {
                        this.$message.warning('请选择系数！')
                      }
                    }
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                  // 条件3--都没值
                    if (this.data.conditions[3].connector !== '' || this.data.conditions[3].conditionKpi !== '' || this.data.conditions[3].conditionOperator !== '' || this.data.conditions[3].conditionValue !== '') {
                    // 条件4--其中有一个有值
                      this.$message.warning('请填写if前置条件！')
                    } else if (this.data.conditions[3].connector === '' && this.data.conditions[3].conditionKpi === '' && this.data.conditions[3].conditionOperator === '' && this.data.conditions[3].conditionValue === '') {
                    // 条件4--都没值
                    // 判断系数
                      if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                        this.row.kpiAchCondition = this.data
                        this.visible = false
                      } else {
                        this.$message.warning('请选择系数！')
                      }
                    }
                  }
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  if (this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '' || this.data.conditions[2].conditionValue !== '') {
                    // 条件3--其中有一个有值
                    this.$message.warning('请填写if前置条件！')
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                    // 条件3--都没值
                    if (this.data.conditions[3].connector !== '' || this.data.conditions[3].conditionKpi !== '' || this.data.conditions[3].conditionOperator !== '' || this.data.conditions[3].conditionValue !== '') {
                    // 条件4--其中有一个有值
                      this.$message.warning('请填写if前置条件！')
                    } else if (this.data.conditions[3].connector === '' && this.data.conditions[3].conditionKpi === '' && this.data.conditions[3].conditionOperator === '' && this.data.conditions[3].conditionValue === '') {
                    // 条件4--都没值
                    // 判断系数
                      if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                        this.row.kpiAchCondition = this.data
                        this.visible = false
                      } else {
                        this.$message.warning('请选择系数！')
                      }
                    }
                  }
                }
              } else if (this.data.conditions[0].conditionKpi === '' && this.data.conditions[0].conditionOperator === '' && this.data.conditions[0].conditionValue === '') {
                // 条件1满足--都没值
                if (this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '' || this.data.conditions[1].conditionValue !== '') {
                  // 条件2--其中有一个有值
                  this.$message.warning('请填写if前置条件！')
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  if (this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '' || this.data.conditions[2].conditionValue !== '') {
                    // 条件3--其中有一个有值
                    this.$message.warning('请填写if前置条件！')
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                    // 条件3--都没值
                    if (this.data.conditions[3].connector !== '' || this.data.conditions[3].conditionKpi !== '' || this.data.conditions[3].conditionOperator !== '' || this.data.conditions[3].conditionValue !== '') {
                    // 条件4--其中有一个有值
                      this.$message.warning('请填写if前置条件！')
                    } else if (this.data.conditions[3].connector === '' && this.data.conditions[3].conditionKpi === '' && this.data.conditions[3].conditionOperator === '' && this.data.conditions[3].conditionValue === '') {
                    // 条件4--都没值
                    // 判断系数
                      if (this.data.thenValue1 === '' && this.data.thenValue2 === '' && this.data.endValue1 === '' && this.data.endValue2 === '') {
                      // 系数--都没值
                        this.row.kpiAchCondition = this.data
                        this.visible = false
                      } else {
                        this.$message.warning('请选择if条件！')
                      }
                    }
                  }
                }
              }
            } else if (this.data.connector0 !== '' && this.data.premiseConditionKpi1 !== '' && this.data.premiseConditionOperator1 !== '' && this.data.premiseConditionValue1 !== '') {
              // 起奖设定2--都有值
              // 判断if条件
              if ((this.data.conditions[0].conditionKpi !== '' || this.data.conditions[0].conditionOperator !== '') && this.data.conditions[0].conditionValue === '') {
                // if条件--KPI和运算符有值判断对应值-1
                this.$message.warning('请填写if条件KPI对应的值！')
              } else if ((this.data.conditions[0].conditionKpi === '' || this.data.conditions[0].conditionOperator === '') && this.data.conditions[0].conditionValue !== '') {
                // if条件--KPI对应值判断对kpi和运算符-1
                this.$message.warning('请填写if条件KPI或者运算符！')
              } else if (this.data.conditions[0].conditionKpi !== '' && this.data.conditions[0].conditionOperator !== '' && this.data.conditions[0].conditionValue !== '') {
                // 条件1满足--都有值
                if ((this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '') && this.data.conditions[1].conditionValue === '') {
                  // if条件2--KPI和运算符有值判断对应值-2
                  this.$message.warning('请填写if条件KPI对应的值！')
                } else if ((this.data.conditions[1].connector === '' || this.data.conditions[1].conditionKpi === '' || this.data.conditions[1].conditionOperator === '') && this.data.conditions[1].conditionValue !== '') {
                  // if条件2--KPI对应值判断对kpi和运算符-2
                  this.$message.warning('请填写if条件KPI或者运算符！')
                } else if (this.data.conditions[1].connector !== '' && this.data.conditions[1].conditionKpi !== '' && this.data.conditions[1].conditionOperator !== '' && this.data.conditions[1].conditionValue !== '') {
                  // 条件2--都有值
                  if ((this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '') && this.data.conditions[2].conditionValue === '') {
                  // if条件3--KPI和运算符有值判断对应值-3
                    this.$message.warning('请填写if条件KPI对应的值！')
                  } else if ((this.data.conditions[2].connector === '' || this.data.conditions[2].conditionKpi === '' || this.data.conditions[2].conditionOperator === '') && this.data.conditions[2].conditionValue !== '') {
                  // if条件3--KPI对应值判断对kpi和运算符-3
                    this.$message.warning('请填写if条件KPI或者运算符！')
                  } else if (this.data.conditions[2].connector !== '' && this.data.conditions[2].conditionKpi !== '' && this.data.conditions[2].conditionOperator !== '' && this.data.conditions[2].conditionValue !== '') {
                  // 条件3--都有值

                    if ((this.data.conditions[3].connector !== '' || this.data.conditions[3].conditionKpi !== '' || this.data.conditions[3].conditionOperator !== '') && this.data.conditions[3].conditionValue === '') {
                      // if条件4--KPI和运算符有值判断对应值-4
                      this.$message.warning('请填写if条件KPI对应的值！')
                    } else if ((this.data.conditions[3].connector === '' || this.data.conditions[3].conditionKpi === '' || this.data.conditions[3].conditionOperator === '') && this.data.conditions[3].conditionValue !== '') {
                      // if条件4--KPI对应值判断对kpi和运算符-4
                      this.$message.warning('请填写if条件KPI或者运算符！')
                    } else if (this.data.conditions[3].connector !== '' && this.data.conditions[3].conditionKpi !== '' && this.data.conditions[3].conditionOperator !== '' && this.data.conditions[3].conditionValue !== '') {
                      // 条件4--都有值
                      // 判断系数
                      if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                        this.row.kpiAchCondition = this.data
                        this.visible = false
                      } else {
                        this.$message.warning('请选择系数！')
                      }
                    } else if (this.data.conditions[3].connector === '' && this.data.conditions[3].conditionKpi === '' && this.data.conditions[3].conditionOperator === '' && this.data.conditions[3].conditionValue === '') {
                      // 条件4--都没值
                      // 判断系数
                      if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                        this.row.kpiAchCondition = this.data
                        this.visible = false
                      } else {
                        this.$message.warning('请选择系数！')
                      }
                    }
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                  // 条件3--都没值
                    if (this.data.conditions[3].connector !== '' || this.data.conditions[3].conditionKpi !== '' || this.data.conditions[3].conditionOperator !== '' || this.data.conditions[3].conditionValue !== '') {
                    // 条件4--其中有一个有值
                      this.$message.warning('请填写if前置条件！')
                    } else if (this.data.conditions[3].connector === '' && this.data.conditions[3].conditionKpi === '' && this.data.conditions[3].conditionOperator === '' && this.data.conditions[3].conditionValue === '') {
                    // 条件4--都没值
                    // 判断系数
                      if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                        this.row.kpiAchCondition = this.data
                        this.visible = false
                      } else {
                        this.$message.warning('请选择系数！')
                      }
                    }
                  }
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  if (this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '' || this.data.conditions[2].conditionValue !== '') {
                    // 条件3--其中有一个有值
                    this.$message.warning('请填写if前置条件！')
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                    // 条件3--都没值
                    if (this.data.conditions[3].connector !== '' || this.data.conditions[3].conditionKpi !== '' || this.data.conditions[3].conditionOperator !== '' || this.data.conditions[3].conditionValue !== '') {
                    // 条件4--其中有一个有值
                      this.$message.warning('请填写if前置条件！')
                    } else if (this.data.conditions[3].connector === '' && this.data.conditions[3].conditionKpi === '' && this.data.conditions[3].conditionOperator === '' && this.data.conditions[3].conditionValue === '') {
                    // 条件4--都没值
                    // 判断系数
                      if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                        this.row.kpiAchCondition = this.data
                        this.visible = false
                      } else {
                        this.$message.warning('请选择系数！')
                      }
                    }
                  }
                }
              } else if (this.data.conditions[0].conditionKpi === '' && this.data.conditions[0].conditionOperator === '' && this.data.conditions[0].conditionValue === '') {
                // 条件1满足--都没值
                if (this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '' || this.data.conditions[1].conditionValue !== '') {
                  // 条件2--其中有一个有值
                  this.$message.warning('请填写if前置条件！')
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  if (this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '' || this.data.conditions[2].conditionValue !== '') {
                    // 条件3--其中有一个有值
                    this.$message.warning('请填写if前置条件！')
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                    // 条件3--都没值
                    if (this.data.conditions[3].connector !== '' || this.data.conditions[3].conditionKpi !== '' || this.data.conditions[3].conditionOperator !== '' || this.data.conditions[3].conditionValue !== '') {
                    // 条件4--其中有一个有值
                      this.$message.warning('请填写if前置条件！')
                    } else if (this.data.conditions[3].connector === '' && this.data.conditions[3].conditionKpi === '' && this.data.conditions[3].conditionOperator === '' && this.data.conditions[3].conditionValue === '') {
                    // 条件4--都没值
                    // 判断系数
                      if (this.data.thenValue1 === '' && this.data.thenValue2 === '' && this.data.endValue1 === '' && this.data.endValue2 === '') {
                      // 系数--都没值
                        this.row.kpiAchCondition = this.data
                        this.visible = false
                      } else {
                        this.$message.warning('请选择if条件！')
                      }
                    }
                  }
                }
              }
            }
          } else if (this.data.premiseConditionKpi === '' && this.data.premiseConditionOperator === '' && this.data.premiseConditionValue === '') {
            // 其奖设定1--都没值
            if (this.data.connector0 !== '' || this.data.premiseConditionKpi1 !== '' || this.data.premiseConditionOperator1 !== '' || this.data.premiseConditionValue1 !== '') {
              // 起奖设定2--其中有一个为空
              this.$message.warning('请填写起奖设定前提条件！')
            } else if (this.data.connector0 === '' && this.data.premiseConditionKpi1 === '' && this.data.premiseConditionOperator1 === '' && this.data.premiseConditionValue1 === '') {
              // 起奖设定2--都没值
              // 判断if条件
              if ((this.data.conditions[0].conditionKpi !== '' || this.data.conditions[0].conditionOperator !== '') && this.data.conditions[0].conditionValue === '') {
                // if条件--KPI和运算符有值判断对应值-1
                this.$message.warning('请填写if条件KPI对应的值！')
              } else if ((this.data.conditions[0].conditionKpi === '' || this.data.conditions[0].conditionOperator === '') && this.data.conditions[0].conditionValue !== '') {
                // if条件--KPI对应值判断对kpi和运算符-1
                this.$message.warning('请填写if条件KPI或者运算符！')
              } else if (this.data.conditions[0].conditionKpi !== '' && this.data.conditions[0].conditionOperator !== '' && this.data.conditions[0].conditionValue !== '') {
                // 条件1满足--都有值
                if ((this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '') && this.data.conditions[1].conditionValue === '') {
                  // if条件2--KPI和运算符有值判断对应值-2
                  this.$message.warning('请填写if条件KPI对应的值！')
                } else if ((this.data.conditions[1].connector === '' || this.data.conditions[1].conditionKpi === '' || this.data.conditions[1].conditionOperator === '') && this.data.conditions[1].conditionValue !== '') {
                  // if条件2--KPI对应值判断对kpi和运算符-2
                  this.$message.warning('请填写if条件KPI或者运算符！')
                } else if (this.data.conditions[1].connector !== '' && this.data.conditions[1].conditionKpi !== '' && this.data.conditions[1].conditionOperator !== '' && this.data.conditions[1].conditionValue !== '') {
                  // 条件2--都有值
                  if ((this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '') && this.data.conditions[2].conditionValue === '') {
                  // if条件3--KPI和运算符有值判断对应值-3
                    this.$message.warning('请填写if条件KPI对应的值！')
                  } else if ((this.data.conditions[2].connector === '' || this.data.conditions[2].conditionKpi === '' || this.data.conditions[2].conditionOperator === '') && this.data.conditions[2].conditionValue !== '') {
                  // if条件3--KPI对应值判断对kpi和运算符-3
                    this.$message.warning('请填写if条件KPI或者运算符！')
                  } else if (this.data.conditions[2].connector !== '' && this.data.conditions[2].conditionKpi !== '' && this.data.conditions[2].conditionOperator !== '' && this.data.conditions[2].conditionValue !== '') {
                  // 条件3--都有值

                    if ((this.data.conditions[3].connector !== '' || this.data.conditions[3].conditionKpi !== '' || this.data.conditions[3].conditionOperator !== '') && this.data.conditions[3].conditionValue === '') {
                      // if条件4--KPI和运算符有值判断对应值-4
                      this.$message.warning('请填写if条件KPI对应的值！')
                    } else if ((this.data.conditions[3].connector === '' || this.data.conditions[3].conditionKpi === '' || this.data.conditions[3].conditionOperator === '') && this.data.conditions[3].conditionValue !== '') {
                      // if条件4--KPI对应值判断对kpi和运算符-4
                      this.$message.warning('请填写if条件KPI或者运算符！')
                    } else if (this.data.conditions[3].connector !== '' && this.data.conditions[3].conditionKpi !== '' && this.data.conditions[3].conditionOperator !== '' && this.data.conditions[3].conditionValue !== '') {
                      // 条件4--都有值
                      // 判断系数
                      if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                        this.row.kpiAchCondition = this.data
                        this.visible = false
                      } else {
                        this.$message.warning('请选择系数！')
                      }
                    } else if (this.data.conditions[3].connector === '' && this.data.conditions[3].conditionKpi === '' && this.data.conditions[3].conditionOperator === '' && this.data.conditions[3].conditionValue === '') {
                      // 条件4--都没值
                      // 判断系数
                      if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                        this.row.kpiAchCondition = this.data
                        this.visible = false
                      } else {
                        this.$message.warning('请选择系数！')
                      }
                    }
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                  // 条件3--都没值
                    if (this.data.conditions[3].connector !== '' || this.data.conditions[3].conditionKpi !== '' || this.data.conditions[3].conditionOperator !== '' || this.data.conditions[3].conditionValue !== '') {
                    // 条件4--其中有一个有值
                      this.$message.warning('请填写if前置条件！')
                    } else if (this.data.conditions[3].connector === '' && this.data.conditions[3].conditionKpi === '' && this.data.conditions[3].conditionOperator === '' && this.data.conditions[3].conditionValue === '') {
                    // 条件4--都没值
                    // 判断系数
                      if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                        this.row.kpiAchCondition = this.data
                        this.visible = false
                      } else {
                        this.$message.warning('请选择系数！')
                      }
                    }
                  }
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  if (this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '' || this.data.conditions[2].conditionValue !== '') {
                    // 条件3--其中有一个有值
                    this.$message.warning('请填写if前置条件！')
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                    // 条件3--都没值
                    if (this.data.conditions[3].connector !== '' || this.data.conditions[3].conditionKpi !== '' || this.data.conditions[3].conditionOperator !== '' || this.data.conditions[3].conditionValue !== '') {
                    // 条件4--其中有一个有值
                      this.$message.warning('请填写if前置条件！')
                    } else if (this.data.conditions[3].connector === '' && this.data.conditions[3].conditionKpi === '' && this.data.conditions[3].conditionOperator === '' && this.data.conditions[3].conditionValue === '') {
                    // 条件4--都没值
                    // 判断系数
                      if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                        this.row.kpiAchCondition = this.data
                        this.visible = false
                      } else {
                        this.$message.warning('请选择系数！')
                      }
                    }
                  }
                }
              } else if (this.data.conditions[0].conditionKpi === '' && this.data.conditions[0].conditionOperator === '' && this.data.conditions[0].conditionValue === '') {
                // 条件1满足--都没值
                if (this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '' || this.data.conditions[1].conditionValue !== '') {
                  // 条件2--其中有一个有值
                  this.$message.warning('请填写if前置条件！')
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  if (this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '' || this.data.conditions[2].conditionValue !== '') {
                    // 条件3--其中有一个有值
                    this.$message.warning('请填写if前置条件！')
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                    // 条件3--都没值
                    if (this.data.conditions[3].connector !== '' || this.data.conditions[3].conditionKpi !== '' || this.data.conditions[3].conditionOperator !== '' || this.data.conditions[3].conditionValue !== '') {
                    // 条件4--其中有一个有值
                      this.$message.warning('请填写if前置条件！')
                    } else if (this.data.conditions[3].connector === '' && this.data.conditions[3].conditionKpi === '' && this.data.conditions[3].conditionOperator === '' && this.data.conditions[3].conditionValue === '') {
                    // 条件4--都没值
                    // 判断系数
                      if (this.data.thenValue1 === '' && this.data.thenValue2 === '' && this.data.endValue1 === '' && this.data.endValue2 === '') {
                      // 系数--都没值
                        this.row.kpiAchCondition = this.data
                        this.visible = false
                      } else {
                        this.$message.warning('请选择if条件！')
                      }
                    }
                  }
                }
              }
            }
          }
        }
      } else if (this.type === 'add') {
        let length = this.data.conditions.length
        if (length === 1) {
          if ((this.data.premiseConditionKpi !== '' || this.data.premiseConditionOperator !== '') && this.data.premiseConditionValue === '') {
            // 起奖设定1--KPI和运算符有值判断对应值
            this.$message.warning('请填写起奖设定KPI对应的值！')
          } else if ((this.data.premiseConditionKpi === '' || this.data.premiseConditionOperator === '') && this.data.premiseConditionValue !== '') {
            // 起奖设定1--KPI对应值判断对kpi和运算符
            this.$message.warning('请选择起奖设定KPI或者运算符！')
          } else if (this.data.premiseConditionKpi !== '' && this.data.premiseConditionOperator !== '' && this.data.premiseConditionValue !== '') {
            // 其奖设定1--都有值
            if ((this.data.connector0 !== '' || this.data.premiseConditionKpi1 !== '' || this.data.premiseConditionOperator1 !== '') && this.data.premiseConditionValue1 === '') {
              // 起奖设定2--KPI和运算符有值判断对应值
              this.$message.warning('请填写起奖设定KPI对应的值！')
            } else if ((this.data.connector0 === '' || this.data.premiseConditionKpi1 === '' || this.data.premiseConditionOperator1 === '') && this.data.premiseConditionValue1 !== '') {
              // 起奖设定2--KPI对应值判断对kpi和运算符
              this.$message.warning('请选择起奖设定KPI或者运算符！')
            } else if (this.data.connector0 === '' && this.data.premiseConditionKpi1 === '' && this.data.premiseConditionOperator1 === '' && this.data.premiseConditionValue1 === '') {
              // 起奖设定2--都没值
              // 判断if条件
              if ((this.data.conditions[0].conditionKpi !== '' || this.data.conditions[0].conditionOperator !== '') && this.data.conditions[0].conditionValue === '') {
                // if条件--KPI和运算符有值判断对应值-1
                this.$message.warning('请填写if条件KPI对应的值！')
              } else if ((this.data.conditions[0].conditionKpi === '' || this.data.conditions[0].conditionOperator === '') && this.data.conditions[0].conditionValue !== '') {
                // if条件--KPI对应值判断对kpi和运算符-1
                this.$message.warning('请填写if条件KPI或者运算符！')
              } else if (this.data.conditions[0].conditionKpi !== '' && this.data.conditions[0].conditionOperator !== '' && this.data.conditions[0].conditionValue !== '') {
                // 条件1满足--都有值
                // 判断系数
                if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                  // 系数--都有值
                  this.row.kpiAchCondition = this.data
                  this.visible = false
                } else {
                  this.$message.warning('请选择系数！')
                }
              } else if (this.data.conditions[0].conditionKpi === '' && this.data.conditions[0].conditionOperator === '' && this.data.conditions[0].conditionValue === '') {
                // 条件1满足--都没值
                // 判断系数
                if (this.data.thenValue1 === '' && this.data.thenValue2 === '' && this.data.endValue1 === '' && this.data.endValue2 === '') {
                  // 系数--都没值
                  this.row.kpiAchCondition = this.data
                  this.visible = false
                } else {
                  this.$message.warning('请选择if条件！')
                }
              }
            } else if (this.data.connector0 !== '' && this.data.premiseConditionKpi1 !== '' && this.data.premiseConditionOperator1 !== '' && this.data.premiseConditionValue1 !== '') {
              // 起奖设定2--都有值
              // 判断if条件
              if ((this.data.conditions[0].conditionKpi !== '' || this.data.conditions[0].conditionOperator !== '') && this.data.conditions[0].conditionValue === '') {
                // if条件--KPI和运算符有值判断对应值-1
                this.$message.warning('请填写if条件KPI对应的值！')
              } else if ((this.data.conditions[0].conditionKpi === '' || this.data.conditions[0].conditionOperator === '') && this.data.conditions[0].conditionValue !== '') {
                // if条件--KPI对应值判断对kpi和运算符-1
                this.$message.warning('请填写if条件KPI或者运算符！')
              } else if (this.data.conditions[0].conditionKpi !== '' && this.data.conditions[0].conditionOperator !== '' && this.data.conditions[0].conditionValue !== '') {
                // 条件1满足--都有值
                // 判断系数
                if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                  // 系数--都有值
                  this.row.kpiAchCondition = this.data
                  this.visible = false
                } else {
                  this.$message.warning('请选择系数！')
                }
              } else if (this.data.conditions[0].conditionKpi === '' && this.data.conditions[0].conditionOperator === '' && this.data.conditions[0].conditionValue === '') {
                // 条件1满足--都没值
                // 判断系数
                if (this.data.thenValue1 === '' && this.data.thenValue2 === '' && this.data.endValue1 === '' && this.data.endValue2 === '') {
                  // 系数--都没值
                  this.row.kpiAchCondition = this.data
                  this.visible = false
                } else {
                  this.$message.warning('请选择if条件！')
                }
              }
            }
          } else if (this.data.premiseConditionKpi === '' && this.data.premiseConditionOperator === '' && this.data.premiseConditionValue === '') {
            // 其奖设定1--都没值
            if (this.data.connector0 !== '' || this.data.premiseConditionKpi1 !== '' || this.data.premiseConditionOperator1 !== '' || this.data.premiseConditionValue1 !== '') {
              // 起奖设定2--其中有一个为空
              this.$message.warning('请填写起奖设定前提条件！')
            } else if (this.data.connector0 === '' && this.data.premiseConditionKpi1 === '' && this.data.premiseConditionOperator1 === '' && this.data.premiseConditionValue1 === '') {
              // 起奖设定2--都没值
              // 判断if条件
              if ((this.data.conditions[0].conditionKpi !== '' || this.data.conditions[0].conditionOperator !== '') && this.data.conditions[0].conditionValue === '') {
                // if条件--KPI和运算符有值判断对应值-1
                this.$message.warning('请填写if条件KPI对应的值！')
              } else if ((this.data.conditions[0].conditionKpi === '' || this.data.conditions[0].conditionOperator === '') && this.data.conditions[0].conditionValue !== '') {
                // if条件--KPI对应值判断对kpi和运算符-1
                this.$message.warning('请填写if条件KPI或者运算符！')
              } else if (this.data.conditions[0].conditionKpi !== '' && this.data.conditions[0].conditionOperator !== '' && this.data.conditions[0].conditionValue !== '') {
                // 条件1满足--都有值
                // 判断系数
                if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                  // 系数--都有值
                  this.row.kpiAchCondition = this.data
                  this.visible = false
                } else {
                  this.$message.warning('请选择系数！')
                }
              } else if (this.data.conditions[0].conditionKpi === '' && this.data.conditions[0].conditionOperator === '' && this.data.conditions[0].conditionValue === '') {
                // 条件1满足--都没值
                // 判断系数
                if (this.data.thenValue1 === '' && this.data.thenValue2 === '' && this.data.endValue1 === '' && this.data.endValue2 === '') {
                  // 系数--都没值
                  this.row.kpiAchCondition = this.data
                  this.visible = false
                } else {
                  this.$message.warning('请选择if条件！')
                }
              }
            }
          }
        } else if (length === 2) {
          if ((this.data.premiseConditionKpi !== '' || this.data.premiseConditionOperator !== '') && this.data.premiseConditionValue === '') {
            // 起奖设定1--KPI和运算符有值判断对应值
            this.$message.warning('请填写起奖设定KPI对应的值！')
          } else if ((this.data.premiseConditionKpi === '' || this.data.premiseConditionOperator === '') && this.data.premiseConditionValue !== '') {
            // 起奖设定1--KPI对应值判断对kpi和运算符
            this.$message.warning('请选择起奖设定KPI或者运算符！')
          } else if (this.data.premiseConditionKpi !== '' && this.data.premiseConditionOperator !== '' && this.data.premiseConditionValue !== '') {
            // 其奖设定1--都有值
            if ((this.data.connector0 !== '' || this.data.premiseConditionKpi1 !== '' || this.data.premiseConditionOperator1 !== '') && this.data.premiseConditionValue1 === '') {
              // 起奖设定2--KPI和运算符有值判断对应值
              this.$message.warning('请填写起奖设定KPI对应的值！')
            } else if ((this.data.connector0 === '' || this.data.premiseConditionKpi1 === '' || this.data.premiseConditionOperator1 === '') && this.data.premiseConditionValue1 !== '') {
              // 起奖设定2--KPI对应值判断对kpi和运算符
              this.$message.warning('请选择起奖设定KPI或者运算符！')
            } else if (this.data.connector0 === '' && this.data.premiseConditionKpi1 === '' && this.data.premiseConditionOperator1 === '' && this.data.premiseConditionValue1 === '') {
              // 起奖设定2--都没值
              // 判断if条件
              if ((this.data.conditions[0].conditionKpi !== '' || this.data.conditions[0].conditionOperator !== '') && this.data.conditions[0].conditionValue === '') {
                // if条件--KPI和运算符有值判断对应值-1
                this.$message.warning('请填写if条件KPI对应的值！')
              } else if ((this.data.conditions[0].conditionKpi === '' || this.data.conditions[0].conditionOperator === '') && this.data.conditions[0].conditionValue !== '') {
                // if条件--KPI对应值判断对kpi和运算符-1
                this.$message.warning('请填写if条件KPI或者运算符！')
              } else if (this.data.conditions[0].conditionKpi !== '' && this.data.conditions[0].conditionOperator !== '' && this.data.conditions[0].conditionValue !== '') {
                // 条件1满足--都有值
                if ((this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '') && this.data.conditions[1].conditionValue === '') {
                  // if条件2--KPI和运算符有值判断对应值-2
                  this.$message.warning('请填写if条件KPI对应的值！')
                } else if ((this.data.conditions[1].connector === '' || this.data.conditions[1].conditionKpi === '' || this.data.conditions[1].conditionOperator === '') && this.data.conditions[1].conditionValue !== '') {
                  // if条件2--KPI对应值判断对kpi和运算符-2
                  this.$message.warning('请填写if条件KPI或者运算符！')
                } else if (this.data.conditions[1].connector !== '' && this.data.conditions[1].conditionKpi !== '' && this.data.conditions[1].conditionOperator !== '' && this.data.conditions[1].conditionValue !== '') {
                  // 条件2--都有值
                  // 判断系数
                  if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                  // 系数--都有值
                    this.row.kpiAchCondition = this.data
                    this.visible = false
                  } else {
                    this.$message.warning('请选择系数！')
                  }
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  // 判断系数
                  if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                  // 系数--都有值
                    this.row.kpiAchCondition = this.data
                    this.visible = false
                  } else {
                    this.$message.warning('请选择系数！')
                  }
                }
              } else if (this.data.conditions[0].conditionKpi === '' && this.data.conditions[0].conditionOperator === '' && this.data.conditions[0].conditionValue === '') {
                // 条件1满足--都没值
                if (this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '' || this.data.conditions[1].conditionValue !== '') {
                  // 条件2--其中有一个有值
                  this.$message.warning('请填写if前置条件！')
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  // 判断系数
                  if (this.data.thenValue1 === '' && this.data.thenValue2 === '' && this.data.endValue1 === '' && this.data.endValue2 === '') {
                  // 系数--都没值
                    this.row.kpiAchCondition = this.data
                    this.visible = false
                  } else {
                    this.$message.warning('请选择if条件！')
                  }
                }
              }
            } else if (this.data.connector0 !== '' && this.data.premiseConditionKpi1 !== '' && this.data.premiseConditionOperator1 !== '' && this.data.premiseConditionValue1 !== '') {
              // 起奖设定2--都有值
              // 判断if条件
              if ((this.data.conditions[0].conditionKpi !== '' || this.data.conditions[0].conditionOperator !== '') && this.data.conditions[0].conditionValue === '') {
                // if条件--KPI和运算符有值判断对应值-1
                this.$message.warning('请填写if条件KPI对应的值！')
              } else if ((this.data.conditions[0].conditionKpi === '' || this.data.conditions[0].conditionOperator === '') && this.data.conditions[0].conditionValue !== '') {
                // if条件--KPI对应值判断对kpi和运算符-1
                this.$message.warning('请填写if条件KPI或者运算符！')
              } else if (this.data.conditions[0].conditionKpi !== '' && this.data.conditions[0].conditionOperator !== '' && this.data.conditions[0].conditionValue !== '') {
                // 条件1满足--都有值
                if ((this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '') && this.data.conditions[1].conditionValue === '') {
                  // if条件2--KPI和运算符有值判断对应值-2
                  this.$message.warning('请填写if条件KPI对应的值！')
                } else if ((this.data.conditions[1].connector === '' || this.data.conditions[1].conditionKpi === '' || this.data.conditions[1].conditionOperator === '') && this.data.conditions[1].conditionValue !== '') {
                  // if条件2--KPI对应值判断对kpi和运算符-2
                  this.$message.warning('请填写if条件KPI或者运算符！')
                } else if (this.data.conditions[1].connector !== '' && this.data.conditions[1].conditionKpi !== '' && this.data.conditions[1].conditionOperator !== '' && this.data.conditions[1].conditionValue !== '') {
                  // 条件2--都有值
                  // 判断系数
                  if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                  // 系数--都有值
                    this.row.kpiAchCondition = this.data
                    this.visible = false
                  } else {
                    this.$message.warning('请选择系数！')
                  }
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  // 判断系数
                  if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                  // 系数--都有值
                    this.row.kpiAchCondition = this.data
                    this.visible = false
                  } else {
                    this.$message.warning('请选择系数！')
                  }
                }
              } else if (this.data.conditions[0].conditionKpi === '' && this.data.conditions[0].conditionOperator === '' && this.data.conditions[0].conditionValue === '') {
                // 条件1满足--都没值
                if (this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '' || this.data.conditions[1].conditionValue !== '') {
                  // 条件2--其中有一个有值
                  this.$message.warning('请填写if前置条件！')
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  // 判断系数
                  if (this.data.thenValue1 === '' && this.data.thenValue2 === '' && this.data.endValue1 === '' && this.data.endValue2 === '') {
                  // 系数--都没值
                    this.row.kpiAchCondition = this.data
                    this.visible = false
                  } else {
                    this.$message.warning('请选择if条件！')
                  }
                }
              }
            }
          } else if (this.data.premiseConditionKpi === '' && this.data.premiseConditionOperator === '' && this.data.premiseConditionValue === '') {
            // 其奖设定1--都没值
            if (this.data.connector0 !== '' || this.data.premiseConditionKpi1 !== '' || this.data.premiseConditionOperator1 !== '' || this.data.premiseConditionValue1 !== '') {
              // 起奖设定2--其中有一个为空
              this.$message.warning('请填写起奖设定前提条件！')
            } else if (this.data.connector0 === '' && this.data.premiseConditionKpi1 === '' && this.data.premiseConditionOperator1 === '' && this.data.premiseConditionValue1 === '') {
              // 起奖设定2--都没值
              // 判断if条件
              if ((this.data.conditions[0].conditionKpi !== '' || this.data.conditions[0].conditionOperator !== '') && this.data.conditions[0].conditionValue === '') {
                // if条件--KPI和运算符有值判断对应值-1
                this.$message.warning('请填写if条件KPI对应的值！')
              } else if ((this.data.conditions[0].conditionKpi === '' || this.data.conditions[0].conditionOperator === '') && this.data.conditions[0].conditionValue !== '') {
                // if条件--KPI对应值判断对kpi和运算符-1
                this.$message.warning('请填写if条件KPI或者运算符！')
              } else if (this.data.conditions[0].conditionKpi !== '' && this.data.conditions[0].conditionOperator !== '' && this.data.conditions[0].conditionValue !== '') {
                // 条件1满足--都有值
                if ((this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '') && this.data.conditions[1].conditionValue === '') {
                  // if条件2--KPI和运算符有值判断对应值-2
                  this.$message.warning('请填写if条件KPI对应的值！')
                } else if ((this.data.conditions[1].connector === '' || this.data.conditions[1].conditionKpi === '' || this.data.conditions[1].conditionOperator === '') && this.data.conditions[1].conditionValue !== '') {
                  // if条件2--KPI对应值判断对kpi和运算符-2
                  this.$message.warning('请填写if条件KPI或者运算符！')
                } else if (this.data.conditions[1].connector !== '' && this.data.conditions[1].conditionKpi !== '' && this.data.conditions[1].conditionOperator !== '' && this.data.conditions[1].conditionValue !== '') {
                  // 条件2--都有值
                  // 判断系数
                  if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                  // 系数--都有值
                    this.row.kpiAchCondition = this.data
                    this.visible = false
                  } else {
                    this.$message.warning('请选择系数！')
                  }
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  // 判断系数
                  if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                  // 系数--都有值
                    this.row.kpiAchCondition = this.data
                    this.visible = false
                  } else {
                    this.$message.warning('请选择系数！')
                  }
                }
              } else if (this.data.conditions[0].conditionKpi === '' && this.data.conditions[0].conditionOperator === '' && this.data.conditions[0].conditionValue === '') {
                // 条件1满足--都没值
                if (this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '' || this.data.conditions[1].conditionValue !== '') {
                  // 条件2--其中有一个有值
                  this.$message.warning('请填写if前置条件！')
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  // 判断系数
                  if (this.data.thenValue1 === '' && this.data.thenValue2 === '' && this.data.endValue1 === '' && this.data.endValue2 === '') {
                  // 系数--都没值
                    this.row.kpiAchCondition = this.data
                    this.visible = false
                  } else {
                    this.$message.warning('请选择if条件！')
                  }
                }
              }
            }
          }
        } else if (length === 3) {
          if ((this.data.premiseConditionKpi !== '' || this.data.premiseConditionOperator !== '') && this.data.premiseConditionValue === '') {
            // 起奖设定1--KPI和运算符有值判断对应值
            this.$message.warning('请填写起奖设定KPI对应的值！')
          } else if ((this.data.premiseConditionKpi === '' || this.data.premiseConditionOperator === '') && this.data.premiseConditionValue !== '') {
            // 起奖设定1--KPI对应值判断对kpi和运算符
            this.$message.warning('请选择起奖设定KPI或者运算符！')
          } else if (this.data.premiseConditionKpi !== '' && this.data.premiseConditionOperator !== '' && this.data.premiseConditionValue !== '') {
            // 其奖设定1--都有值
            if ((this.data.connector0 !== '' || this.data.premiseConditionKpi1 !== '' || this.data.premiseConditionOperator1 !== '') && this.data.premiseConditionValue1 === '') {
              // 起奖设定2--KPI和运算符有值判断对应值
              this.$message.warning('请填写起奖设定KPI对应的值！')
            } else if ((this.data.connector0 === '' || this.data.premiseConditionKpi1 === '' || this.data.premiseConditionOperator1 === '') && this.data.premiseConditionValue1 !== '') {
              // 起奖设定2--KPI对应值判断对kpi和运算符
              this.$message.warning('请选择起奖设定KPI或者运算符！')
            } else if (this.data.connector0 === '' && this.data.premiseConditionKpi1 === '' && this.data.premiseConditionOperator1 === '' && this.data.premiseConditionValue1 === '') {
              // 起奖设定2--都没值
              // 判断if条件
              if ((this.data.conditions[0].conditionKpi !== '' || this.data.conditions[0].conditionOperator !== '') && this.data.conditions[0].conditionValue === '') {
                // if条件--KPI和运算符有值判断对应值-1
                this.$message.warning('请填写if条件KPI对应的值！')
              } else if ((this.data.conditions[0].conditionKpi === '' || this.data.conditions[0].conditionOperator === '') && this.data.conditions[0].conditionValue !== '') {
                // if条件--KPI对应值判断对kpi和运算符-1
                this.$message.warning('请填写if条件KPI或者运算符！')
              } else if (this.data.conditions[0].conditionKpi !== '' && this.data.conditions[0].conditionOperator !== '' && this.data.conditions[0].conditionValue !== '') {
                // 条件1满足--都有值
                if ((this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '') && this.data.conditions[1].conditionValue === '') {
                  // if条件2--KPI和运算符有值判断对应值-2
                  this.$message.warning('请填写if条件KPI对应的值！')
                } else if ((this.data.conditions[1].connector === '' || this.data.conditions[1].conditionKpi === '' || this.data.conditions[1].conditionOperator === '') && this.data.conditions[1].conditionValue !== '') {
                  // if条件2--KPI对应值判断对kpi和运算符-2
                  this.$message.warning('请填写if条件KPI或者运算符！')
                } else if (this.data.conditions[1].connector !== '' && this.data.conditions[1].conditionKpi !== '' && this.data.conditions[1].conditionOperator !== '' && this.data.conditions[1].conditionValue !== '') {
                  // 条件2--都有值
                  if ((this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '') && this.data.conditions[2].conditionValue === '') {
                  // if条件3--KPI和运算符有值判断对应值-3
                    this.$message.warning('请填写if条件KPI对应的值！')
                  } else if ((this.data.conditions[2].connector === '' || this.data.conditions[2].conditionKpi === '' || this.data.conditions[2].conditionOperator === '') && this.data.conditions[2].conditionValue !== '') {
                  // if条件3--KPI对应值判断对kpi和运算符-3
                    this.$message.warning('请填写if条件KPI或者运算符！')
                  } else if (this.data.conditions[2].connector !== '' && this.data.conditions[2].conditionKpi !== '' && this.data.conditions[2].conditionOperator !== '' && this.data.conditions[2].conditionValue !== '') {
                  // 条件3--都有值
                  // 判断系数
                    if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                      this.row.kpiAchCondition = this.data
                      this.visible = false
                    } else {
                      this.$message.warning('请选择系数！')
                    }
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                  // 条件3--都没值
                  // 判断系数
                    if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                      this.row.kpiAchCondition = this.data
                      this.visible = false
                    } else {
                      this.$message.warning('请选择系数！')
                    }
                  }
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  if (this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '' || this.data.conditions[2].conditionValue !== '') {
                    // 条件3--其中有一个有值
                    this.$message.warning('请填写if前置条件！')
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                    // 条件3--都没值
                    // 判断系数
                    if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                      this.row.kpiAchCondition = this.data
                      this.visible = false
                    } else {
                      this.$message.warning('请选择系数！')
                    }
                  }
                }
              } else if (this.data.conditions[0].conditionKpi === '' && this.data.conditions[0].conditionOperator === '' && this.data.conditions[0].conditionValue === '') {
                // 条件1满足--都没值
                if (this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '' || this.data.conditions[1].conditionValue !== '') {
                  // 条件2--其中有一个有值
                  this.$message.warning('请填写if前置条件！')
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  if (this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '' || this.data.conditions[2].conditionValue !== '') {
                    // 条件3--其中有一个有值
                    this.$message.warning('请填写if前置条件！')
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                    // 条件3--都没值
                    // 判断系数
                    if (this.data.thenValue1 === '' && this.data.thenValue2 === '' && this.data.endValue1 === '' && this.data.endValue2 === '') {
                      // 系数--都没值
                      this.row.kpiAchCondition = this.data
                      this.visible = false
                    } else {
                      this.$message.warning('请选择if条件！')
                    }
                  }
                }
              }
            } else if (this.data.connector0 !== '' && this.data.premiseConditionKpi1 !== '' && this.data.premiseConditionOperator1 !== '' && this.data.premiseConditionValue1 !== '') {
              // 起奖设定2--都有值
              // 判断if条件
              if ((this.data.conditions[0].conditionKpi !== '' || this.data.conditions[0].conditionOperator !== '') && this.data.conditions[0].conditionValue === '') {
                // if条件--KPI和运算符有值判断对应值-1
                this.$message.warning('请填写if条件KPI对应的值！')
              } else if ((this.data.conditions[0].conditionKpi === '' || this.data.conditions[0].conditionOperator === '') && this.data.conditions[0].conditionValue !== '') {
                // if条件--KPI对应值判断对kpi和运算符-1
                this.$message.warning('请填写if条件KPI或者运算符！')
              } else if (this.data.conditions[0].conditionKpi !== '' && this.data.conditions[0].conditionOperator !== '' && this.data.conditions[0].conditionValue !== '') {
                // 条件1满足--都有值
                if ((this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '') && this.data.conditions[1].conditionValue === '') {
                  // if条件2--KPI和运算符有值判断对应值-2
                  this.$message.warning('请填写if条件KPI对应的值！')
                } else if ((this.data.conditions[1].connector === '' || this.data.conditions[1].conditionKpi === '' || this.data.conditions[1].conditionOperator === '') && this.data.conditions[1].conditionValue !== '') {
                  // if条件2--KPI对应值判断对kpi和运算符-2
                  this.$message.warning('请填写if条件KPI或者运算符！')
                } else if (this.data.conditions[1].connector !== '' && this.data.conditions[1].conditionKpi !== '' && this.data.conditions[1].conditionOperator !== '' && this.data.conditions[1].conditionValue !== '') {
                  // 条件2--都有值
                  if ((this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '') && this.data.conditions[2].conditionValue === '') {
                  // if条件3--KPI和运算符有值判断对应值-3
                    this.$message.warning('请填写if条件KPI对应的值！')
                  } else if ((this.data.conditions[2].connector === '' || this.data.conditions[2].conditionKpi === '' || this.data.conditions[2].conditionOperator === '') && this.data.conditions[2].conditionValue !== '') {
                  // if条件3--KPI对应值判断对kpi和运算符-3
                    this.$message.warning('请填写if条件KPI或者运算符！')
                  } else if (this.data.conditions[2].connector !== '' && this.data.conditions[2].conditionKpi !== '' && this.data.conditions[2].conditionOperator !== '' && this.data.conditions[2].conditionValue !== '') {
                  // 条件3--都有值
                  // 判断系数
                    if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                      this.row.kpiAchCondition = this.data
                      this.visible = false
                    } else {
                      this.$message.warning('请选择系数！')
                    }
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                  // 条件3--都没值
                  // 判断系数
                    if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                      this.row.kpiAchCondition = this.data
                      this.visible = false
                    } else {
                      this.$message.warning('请选择系数！')
                    }
                  }
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  if (this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '' || this.data.conditions[2].conditionValue !== '') {
                    // 条件3--其中有一个有值
                    this.$message.warning('请填写if前置条件！')
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                    // 条件3--都没值
                    // 判断系数
                    if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                      this.row.kpiAchCondition = this.data
                      this.visible = false
                    } else {
                      this.$message.warning('请选择系数！')
                    }
                  }
                }
              } else if (this.data.conditions[0].conditionKpi === '' && this.data.conditions[0].conditionOperator === '' && this.data.conditions[0].conditionValue === '') {
                // 条件1满足--都没值
                if (this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '' || this.data.conditions[1].conditionValue !== '') {
                  // 条件2--其中有一个有值
                  this.$message.warning('请填写if前置条件！')
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  if (this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '' || this.data.conditions[2].conditionValue !== '') {
                    // 条件3--其中有一个有值
                    this.$message.warning('请填写if前置条件！')
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                    // 条件3--都没值
                    // 判断系数
                    if (this.data.thenValue1 === '' && this.data.thenValue2 === '' && this.data.endValue1 === '' && this.data.endValue2 === '') {
                      // 系数--都没值
                      this.row.kpiAchCondition = this.data
                      this.visible = false
                    } else {
                      this.$message.warning('请选择if条件！')
                    }
                  }
                }
              }
            }
          } else if (this.data.premiseConditionKpi === '' && this.data.premiseConditionOperator === '' && this.data.premiseConditionValue === '') {
            // 其奖设定1--都没值
            if (this.data.connector0 !== '' || this.data.premiseConditionKpi1 !== '' || this.data.premiseConditionOperator1 !== '' || this.data.premiseConditionValue1 !== '') {
              // 起奖设定2--其中有一个为空
              this.$message.warning('请填写起奖设定前提条件！')
            } else if (this.data.connector0 === '' && this.data.premiseConditionKpi1 === '' && this.data.premiseConditionOperator1 === '' && this.data.premiseConditionValue1 === '') {
              // 起奖设定2--都没值
              // 判断if条件
              if ((this.data.conditions[0].conditionKpi !== '' || this.data.conditions[0].conditionOperator !== '') && this.data.conditions[0].conditionValue === '') {
                // if条件--KPI和运算符有值判断对应值-1
                this.$message.warning('请填写if条件KPI对应的值！')
              } else if ((this.data.conditions[0].conditionKpi === '' || this.data.conditions[0].conditionOperator === '') && this.data.conditions[0].conditionValue !== '') {
                // if条件--KPI对应值判断对kpi和运算符-1
                this.$message.warning('请填写if条件KPI或者运算符！')
              } else if (this.data.conditions[0].conditionKpi !== '' && this.data.conditions[0].conditionOperator !== '' && this.data.conditions[0].conditionValue !== '') {
                // 条件1满足--都有值
                if ((this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '') && this.data.conditions[1].conditionValue === '') {
                  // if条件2--KPI和运算符有值判断对应值-2
                  this.$message.warning('请填写if条件KPI对应的值！')
                } else if ((this.data.conditions[1].connector === '' || this.data.conditions[1].conditionKpi === '' || this.data.conditions[1].conditionOperator === '') && this.data.conditions[1].conditionValue !== '') {
                  // if条件2--KPI对应值判断对kpi和运算符-2
                  this.$message.warning('请填写if条件KPI或者运算符！')
                } else if (this.data.conditions[1].connector !== '' && this.data.conditions[1].conditionKpi !== '' && this.data.conditions[1].conditionOperator !== '' && this.data.conditions[1].conditionValue !== '') {
                  // 条件2--都有值
                  if ((this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '') && this.data.conditions[2].conditionValue === '') {
                  // if条件3--KPI和运算符有值判断对应值-3
                    this.$message.warning('请填写if条件KPI对应的值！')
                  } else if ((this.data.conditions[2].connector === '' || this.data.conditions[2].conditionKpi === '' || this.data.conditions[2].conditionOperator === '') && this.data.conditions[2].conditionValue !== '') {
                  // if条件3--KPI对应值判断对kpi和运算符-3
                    this.$message.warning('请填写if条件KPI或者运算符！')
                  } else if (this.data.conditions[2].connector !== '' && this.data.conditions[2].conditionKpi !== '' && this.data.conditions[2].conditionOperator !== '' && this.data.conditions[2].conditionValue !== '') {
                  // 条件3--都有值
                  // 判断系数
                    if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                      this.row.kpiAchCondition = this.data
                      this.visible = false
                    } else {
                      this.$message.warning('请选择系数！')
                    }
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                  // 条件3--都没值
                  // 判断系数
                    if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                      this.row.kpiAchCondition = this.data
                      this.visible = false
                    } else {
                      this.$message.warning('请选择系数！')
                    }
                  }
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  if (this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '' || this.data.conditions[2].conditionValue !== '') {
                    // 条件3--其中有一个有值
                    this.$message.warning('请填写if前置条件！')
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                    // 条件3--都没值
                    // 判断系数
                    if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                      this.row.kpiAchCondition = this.data
                      this.visible = false
                    } else {
                      this.$message.warning('请选择系数！')
                    }
                  }
                }
              } else if (this.data.conditions[0].conditionKpi === '' && this.data.conditions[0].conditionOperator === '' && this.data.conditions[0].conditionValue === '') {
                // 条件1满足--都没值
                if (this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '' || this.data.conditions[1].conditionValue !== '') {
                  // 条件2--其中有一个有值
                  this.$message.warning('请填写if前置条件！')
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  if (this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '' || this.data.conditions[2].conditionValue !== '') {
                    // 条件3--其中有一个有值
                    this.$message.warning('请填写if前置条件！')
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                    // 条件3--都没值
                    // 判断系数
                    if (this.data.thenValue1 === '' && this.data.thenValue2 === '' && this.data.endValue1 === '' && this.data.endValue2 === '') {
                      // 系数--都没值
                      this.row.kpiAchCondition = this.data
                      this.visible = false
                    } else {
                      this.$message.warning('请选择if条件！')
                    }
                  }
                }
              }
            }
          }
        } else if (length === 4) {
          if ((this.data.premiseConditionKpi !== '' || this.data.premiseConditionOperator !== '') && this.data.premiseConditionValue === '') {
            // 起奖设定1--KPI和运算符有值判断对应值
            this.$message.warning('请填写起奖设定KPI对应的值！')
          } else if ((this.data.premiseConditionKpi === '' || this.data.premiseConditionOperator === '') && this.data.premiseConditionValue !== '') {
            // 起奖设定1--KPI对应值判断对kpi和运算符
            this.$message.warning('请选择起奖设定KPI或者运算符！')
          } else if (this.data.premiseConditionKpi !== '' && this.data.premiseConditionOperator !== '' && this.data.premiseConditionValue !== '') {
            // 其奖设定1--都有值
            if ((this.data.connector0 !== '' || this.data.premiseConditionKpi1 !== '' || this.data.premiseConditionOperator1 !== '') && this.data.premiseConditionValue1 === '') {
              // 起奖设定2--KPI和运算符有值判断对应值
              this.$message.warning('请填写起奖设定KPI对应的值！')
            } else if ((this.data.connector0 === '' || this.data.premiseConditionKpi1 === '' || this.data.premiseConditionOperator1 === '') && this.data.premiseConditionValue1 !== '') {
              // 起奖设定2--KPI对应值判断对kpi和运算符
              this.$message.warning('请选择起奖设定KPI或者运算符！')
            } else if (this.data.connector0 === '' && this.data.premiseConditionKpi1 === '' && this.data.premiseConditionOperator1 === '' && this.data.premiseConditionValue1 === '') {
              // 起奖设定2--都没值
              // 判断if条件
              if ((this.data.conditions[0].conditionKpi !== '' || this.data.conditions[0].conditionOperator !== '') && this.data.conditions[0].conditionValue === '') {
                // if条件--KPI和运算符有值判断对应值-1
                this.$message.warning('请填写if条件KPI对应的值！')
              } else if ((this.data.conditions[0].conditionKpi === '' || this.data.conditions[0].conditionOperator === '') && this.data.conditions[0].conditionValue !== '') {
                // if条件--KPI对应值判断对kpi和运算符-1
                this.$message.warning('请填写if条件KPI或者运算符！')
              } else if (this.data.conditions[0].conditionKpi !== '' && this.data.conditions[0].conditionOperator !== '' && this.data.conditions[0].conditionValue !== '') {
                // 条件1满足--都有值
                if ((this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '') && this.data.conditions[1].conditionValue === '') {
                  // if条件2--KPI和运算符有值判断对应值-2
                  this.$message.warning('请填写if条件KPI对应的值！')
                } else if ((this.data.conditions[1].connector === '' || this.data.conditions[1].conditionKpi === '' || this.data.conditions[1].conditionOperator === '') && this.data.conditions[1].conditionValue !== '') {
                  // if条件2--KPI对应值判断对kpi和运算符-2
                  this.$message.warning('请填写if条件KPI或者运算符！')
                } else if (this.data.conditions[1].connector !== '' && this.data.conditions[1].conditionKpi !== '' && this.data.conditions[1].conditionOperator !== '' && this.data.conditions[1].conditionValue !== '') {
                  // 条件2--都有值
                  if ((this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '') && this.data.conditions[2].conditionValue === '') {
                  // if条件3--KPI和运算符有值判断对应值-3
                    this.$message.warning('请填写if条件KPI对应的值！')
                  } else if ((this.data.conditions[2].connector === '' || this.data.conditions[2].conditionKpi === '' || this.data.conditions[2].conditionOperator === '') && this.data.conditions[2].conditionValue !== '') {
                  // if条件3--KPI对应值判断对kpi和运算符-3
                    this.$message.warning('请填写if条件KPI或者运算符！')
                  } else if (this.data.conditions[2].connector !== '' && this.data.conditions[2].conditionKpi !== '' && this.data.conditions[2].conditionOperator !== '' && this.data.conditions[2].conditionValue !== '') {
                  // 条件3--都有值

                    if ((this.data.conditions[3].connector !== '' || this.data.conditions[3].conditionKpi !== '' || this.data.conditions[3].conditionOperator !== '') && this.data.conditions[3].conditionValue === '') {
                      // if条件4--KPI和运算符有值判断对应值-4
                      this.$message.warning('请填写if条件KPI对应的值！')
                    } else if ((this.data.conditions[3].connector === '' || this.data.conditions[3].conditionKpi === '' || this.data.conditions[3].conditionOperator === '') && this.data.conditions[3].conditionValue !== '') {
                      // if条件4--KPI对应值判断对kpi和运算符-4
                      this.$message.warning('请填写if条件KPI或者运算符！')
                    } else if (this.data.conditions[3].connector !== '' && this.data.conditions[3].conditionKpi !== '' && this.data.conditions[3].conditionOperator !== '' && this.data.conditions[3].conditionValue !== '') {
                      // 条件4--都有值
                      // 判断系数
                      if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                        this.row.kpiAchCondition = this.data
                        this.visible = false
                      } else {
                        this.$message.warning('请选择系数！')
                      }
                    } else if (this.data.conditions[3].connector === '' && this.data.conditions[3].conditionKpi === '' && this.data.conditions[3].conditionOperator === '' && this.data.conditions[3].conditionValue === '') {
                      // 条件4--都没值
                      // 判断系数
                      if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                        this.row.kpiAchCondition = this.data
                        this.visible = false
                      } else {
                        this.$message.warning('请选择系数！')
                      }
                    }
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                  // 条件3--都没值
                    if (this.data.conditions[3].connector !== '' || this.data.conditions[3].conditionKpi !== '' || this.data.conditions[3].conditionOperator !== '' || this.data.conditions[3].conditionValue !== '') {
                    // 条件4--其中有一个有值
                      this.$message.warning('请填写if前置条件！')
                    } else if (this.data.conditions[3].connector === '' && this.data.conditions[3].conditionKpi === '' && this.data.conditions[3].conditionOperator === '' && this.data.conditions[3].conditionValue === '') {
                    // 条件4--都没值
                    // 判断系数
                      if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                        this.row.kpiAchCondition = this.data
                        this.visible = false
                      } else {
                        this.$message.warning('请选择系数！')
                      }
                    }
                  }
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  if (this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '' || this.data.conditions[2].conditionValue !== '') {
                    // 条件3--其中有一个有值
                    this.$message.warning('请填写if前置条件！')
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                    // 条件3--都没值
                    if (this.data.conditions[3].connector !== '' || this.data.conditions[3].conditionKpi !== '' || this.data.conditions[3].conditionOperator !== '' || this.data.conditions[3].conditionValue !== '') {
                    // 条件4--其中有一个有值
                      this.$message.warning('请填写if前置条件！')
                    } else if (this.data.conditions[3].connector === '' && this.data.conditions[3].conditionKpi === '' && this.data.conditions[3].conditionOperator === '' && this.data.conditions[3].conditionValue === '') {
                    // 条件4--都没值
                    // 判断系数
                      if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                        this.row.kpiAchCondition = this.data
                        this.visible = false
                      } else {
                        this.$message.warning('请选择系数！')
                      }
                    }
                  }
                }
              } else if (this.data.conditions[0].conditionKpi === '' && this.data.conditions[0].conditionOperator === '' && this.data.conditions[0].conditionValue === '') {
                // 条件1满足--都没值
                if (this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '' || this.data.conditions[1].conditionValue !== '') {
                  // 条件2--其中有一个有值
                  this.$message.warning('请填写if前置条件！')
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  if (this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '' || this.data.conditions[2].conditionValue !== '') {
                    // 条件3--其中有一个有值
                    this.$message.warning('请填写if前置条件！')
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                    // 条件3--都没值
                    if (this.data.conditions[3].connector !== '' || this.data.conditions[3].conditionKpi !== '' || this.data.conditions[3].conditionOperator !== '' || this.data.conditions[3].conditionValue !== '') {
                    // 条件4--其中有一个有值
                      this.$message.warning('请填写if前置条件！')
                    } else if (this.data.conditions[3].connector === '' && this.data.conditions[3].conditionKpi === '' && this.data.conditions[3].conditionOperator === '' && this.data.conditions[3].conditionValue === '') {
                    // 条件4--都没值
                    // 判断系数
                      if (this.data.thenValue1 === '' && this.data.thenValue2 === '' && this.data.endValue1 === '' && this.data.endValue2 === '') {
                      // 系数--都没值
                        this.row.kpiAchCondition = this.data
                        this.visible = false
                      } else {
                        this.$message.warning('请选择if条件！')
                      }
                    }
                  }
                }
              }
            } else if (this.data.connector0 !== '' && this.data.premiseConditionKpi1 !== '' && this.data.premiseConditionOperator1 !== '' && this.data.premiseConditionValue1 !== '') {
              // 起奖设定2--都有值
              // 判断if条件
              if ((this.data.conditions[0].conditionKpi !== '' || this.data.conditions[0].conditionOperator !== '') && this.data.conditions[0].conditionValue === '') {
                // if条件--KPI和运算符有值判断对应值-1
                this.$message.warning('请填写if条件KPI对应的值！')
              } else if ((this.data.conditions[0].conditionKpi === '' || this.data.conditions[0].conditionOperator === '') && this.data.conditions[0].conditionValue !== '') {
                // if条件--KPI对应值判断对kpi和运算符-1
                this.$message.warning('请填写if条件KPI或者运算符！')
              } else if (this.data.conditions[0].conditionKpi !== '' && this.data.conditions[0].conditionOperator !== '' && this.data.conditions[0].conditionValue !== '') {
                // 条件1满足--都有值
                if ((this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '') && this.data.conditions[1].conditionValue === '') {
                  // if条件2--KPI和运算符有值判断对应值-2
                  this.$message.warning('请填写if条件KPI对应的值！')
                } else if ((this.data.conditions[1].connector === '' || this.data.conditions[1].conditionKpi === '' || this.data.conditions[1].conditionOperator === '') && this.data.conditions[1].conditionValue !== '') {
                  // if条件2--KPI对应值判断对kpi和运算符-2
                  this.$message.warning('请填写if条件KPI或者运算符！')
                } else if (this.data.conditions[1].connector !== '' && this.data.conditions[1].conditionKpi !== '' && this.data.conditions[1].conditionOperator !== '' && this.data.conditions[1].conditionValue !== '') {
                  // 条件2--都有值
                  if ((this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '') && this.data.conditions[2].conditionValue === '') {
                  // if条件3--KPI和运算符有值判断对应值-3
                    this.$message.warning('请填写if条件KPI对应的值！')
                  } else if ((this.data.conditions[2].connector === '' || this.data.conditions[2].conditionKpi === '' || this.data.conditions[2].conditionOperator === '') && this.data.conditions[2].conditionValue !== '') {
                  // if条件3--KPI对应值判断对kpi和运算符-3
                    this.$message.warning('请填写if条件KPI或者运算符！')
                  } else if (this.data.conditions[2].connector !== '' && this.data.conditions[2].conditionKpi !== '' && this.data.conditions[2].conditionOperator !== '' && this.data.conditions[2].conditionValue !== '') {
                  // 条件3--都有值

                    if ((this.data.conditions[3].connector !== '' || this.data.conditions[3].conditionKpi !== '' || this.data.conditions[3].conditionOperator !== '') && this.data.conditions[3].conditionValue === '') {
                      // if条件4--KPI和运算符有值判断对应值-4
                      this.$message.warning('请填写if条件KPI对应的值！')
                    } else if ((this.data.conditions[3].connector === '' || this.data.conditions[3].conditionKpi === '' || this.data.conditions[3].conditionOperator === '') && this.data.conditions[3].conditionValue !== '') {
                      // if条件4--KPI对应值判断对kpi和运算符-4
                      this.$message.warning('请填写if条件KPI或者运算符！')
                    } else if (this.data.conditions[3].connector !== '' && this.data.conditions[3].conditionKpi !== '' && this.data.conditions[3].conditionOperator !== '' && this.data.conditions[3].conditionValue !== '') {
                      // 条件4--都有值
                      // 判断系数
                      if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                        this.row.kpiAchCondition = this.data
                        this.visible = false
                      } else {
                        this.$message.warning('请选择系数！')
                      }
                    } else if (this.data.conditions[3].connector === '' && this.data.conditions[3].conditionKpi === '' && this.data.conditions[3].conditionOperator === '' && this.data.conditions[3].conditionValue === '') {
                      // 条件4--都没值
                      // 判断系数
                      if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                        this.row.kpiAchCondition = this.data
                        this.visible = false
                      } else {
                        this.$message.warning('请选择系数！')
                      }
                    }
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                  // 条件3--都没值
                    if (this.data.conditions[3].connector !== '' || this.data.conditions[3].conditionKpi !== '' || this.data.conditions[3].conditionOperator !== '' || this.data.conditions[3].conditionValue !== '') {
                    // 条件4--其中有一个有值
                      this.$message.warning('请填写if前置条件！')
                    } else if (this.data.conditions[3].connector === '' && this.data.conditions[3].conditionKpi === '' && this.data.conditions[3].conditionOperator === '' && this.data.conditions[3].conditionValue === '') {
                    // 条件4--都没值
                    // 判断系数
                      if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                        this.row.kpiAchCondition = this.data
                        this.visible = false
                      } else {
                        this.$message.warning('请选择系数！')
                      }
                    }
                  }
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  if (this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '' || this.data.conditions[2].conditionValue !== '') {
                    // 条件3--其中有一个有值
                    this.$message.warning('请填写if前置条件！')
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                    // 条件3--都没值
                    if (this.data.conditions[3].connector !== '' || this.data.conditions[3].conditionKpi !== '' || this.data.conditions[3].conditionOperator !== '' || this.data.conditions[3].conditionValue !== '') {
                    // 条件4--其中有一个有值
                      this.$message.warning('请填写if前置条件！')
                    } else if (this.data.conditions[3].connector === '' && this.data.conditions[3].conditionKpi === '' && this.data.conditions[3].conditionOperator === '' && this.data.conditions[3].conditionValue === '') {
                    // 条件4--都没值
                    // 判断系数
                      if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                        this.row.kpiAchCondition = this.data
                        this.visible = false
                      } else {
                        this.$message.warning('请选择系数！')
                      }
                    }
                  }
                }
              } else if (this.data.conditions[0].conditionKpi === '' && this.data.conditions[0].conditionOperator === '' && this.data.conditions[0].conditionValue === '') {
                // 条件1满足--都没值
                if (this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '' || this.data.conditions[1].conditionValue !== '') {
                  // 条件2--其中有一个有值
                  this.$message.warning('请填写if前置条件！')
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  if (this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '' || this.data.conditions[2].conditionValue !== '') {
                    // 条件3--其中有一个有值
                    this.$message.warning('请填写if前置条件！')
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                    // 条件3--都没值
                    if (this.data.conditions[3].connector !== '' || this.data.conditions[3].conditionKpi !== '' || this.data.conditions[3].conditionOperator !== '' || this.data.conditions[3].conditionValue !== '') {
                    // 条件4--其中有一个有值
                      this.$message.warning('请填写if前置条件！')
                    } else if (this.data.conditions[3].connector === '' && this.data.conditions[3].conditionKpi === '' && this.data.conditions[3].conditionOperator === '' && this.data.conditions[3].conditionValue === '') {
                    // 条件4--都没值
                    // 判断系数
                      if (this.data.thenValue1 === '' && this.data.thenValue2 === '' && this.data.endValue1 === '' && this.data.endValue2 === '') {
                      // 系数--都没值
                        this.row.kpiAchCondition = this.data
                        this.visible = false
                      } else {
                        this.$message.warning('请选择if条件！')
                      }
                    }
                  }
                }
              }
            }
          } else if (this.data.premiseConditionKpi === '' && this.data.premiseConditionOperator === '' && this.data.premiseConditionValue === '') {
            // 其奖设定1--都没值
            if (this.data.connector0 !== '' || this.data.premiseConditionKpi1 !== '' || this.data.premiseConditionOperator1 !== '' || this.data.premiseConditionValue1 !== '') {
              // 起奖设定2--其中有一个为空
              this.$message.warning('请填写起奖设定前提条件！')
            } else if (this.data.connector0 === '' && this.data.premiseConditionKpi1 === '' && this.data.premiseConditionOperator1 === '' && this.data.premiseConditionValue1 === '') {
              // 起奖设定2--都没值
              // 判断if条件
              if ((this.data.conditions[0].conditionKpi !== '' || this.data.conditions[0].conditionOperator !== '') && this.data.conditions[0].conditionValue === '') {
                // if条件--KPI和运算符有值判断对应值-1
                this.$message.warning('请填写if条件KPI对应的值！')
              } else if ((this.data.conditions[0].conditionKpi === '' || this.data.conditions[0].conditionOperator === '') && this.data.conditions[0].conditionValue !== '') {
                // if条件--KPI对应值判断对kpi和运算符-1
                this.$message.warning('请填写if条件KPI或者运算符！')
              } else if (this.data.conditions[0].conditionKpi !== '' && this.data.conditions[0].conditionOperator !== '' && this.data.conditions[0].conditionValue !== '') {
                // 条件1满足--都有值
                if ((this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '') && this.data.conditions[1].conditionValue === '') {
                  // if条件2--KPI和运算符有值判断对应值-2
                  this.$message.warning('请填写if条件KPI对应的值！')
                } else if ((this.data.conditions[1].connector === '' || this.data.conditions[1].conditionKpi === '' || this.data.conditions[1].conditionOperator === '') && this.data.conditions[1].conditionValue !== '') {
                  // if条件2--KPI对应值判断对kpi和运算符-2
                  this.$message.warning('请填写if条件KPI或者运算符！')
                } else if (this.data.conditions[1].connector !== '' && this.data.conditions[1].conditionKpi !== '' && this.data.conditions[1].conditionOperator !== '' && this.data.conditions[1].conditionValue !== '') {
                  // 条件2--都有值
                  if ((this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '') && this.data.conditions[2].conditionValue === '') {
                  // if条件3--KPI和运算符有值判断对应值-3
                    this.$message.warning('请填写if条件KPI对应的值！')
                  } else if ((this.data.conditions[2].connector === '' || this.data.conditions[2].conditionKpi === '' || this.data.conditions[2].conditionOperator === '') && this.data.conditions[2].conditionValue !== '') {
                  // if条件3--KPI对应值判断对kpi和运算符-3
                    this.$message.warning('请填写if条件KPI或者运算符！')
                  } else if (this.data.conditions[2].connector !== '' && this.data.conditions[2].conditionKpi !== '' && this.data.conditions[2].conditionOperator !== '' && this.data.conditions[2].conditionValue !== '') {
                  // 条件3--都有值

                    if ((this.data.conditions[3].connector !== '' || this.data.conditions[3].conditionKpi !== '' || this.data.conditions[3].conditionOperator !== '') && this.data.conditions[3].conditionValue === '') {
                      // if条件4--KPI和运算符有值判断对应值-4
                      this.$message.warning('请填写if条件KPI对应的值！')
                    } else if ((this.data.conditions[3].connector === '' || this.data.conditions[3].conditionKpi === '' || this.data.conditions[3].conditionOperator === '') && this.data.conditions[3].conditionValue !== '') {
                      // if条件4--KPI对应值判断对kpi和运算符-4
                      this.$message.warning('请填写if条件KPI或者运算符！')
                    } else if (this.data.conditions[3].connector !== '' && this.data.conditions[3].conditionKpi !== '' && this.data.conditions[3].conditionOperator !== '' && this.data.conditions[3].conditionValue !== '') {
                      // 条件4--都有值
                      // 判断系数
                      if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                        this.row.kpiAchCondition = this.data
                        this.visible = false
                      } else {
                        this.$message.warning('请选择系数！')
                      }
                    } else if (this.data.conditions[3].connector === '' && this.data.conditions[3].conditionKpi === '' && this.data.conditions[3].conditionOperator === '' && this.data.conditions[3].conditionValue === '') {
                      // 条件4--都没值
                      // 判断系数
                      if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                        this.row.kpiAchCondition = this.data
                        this.visible = false
                      } else {
                        this.$message.warning('请选择系数！')
                      }
                    }
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                  // 条件3--都没值
                    if (this.data.conditions[3].connector !== '' || this.data.conditions[3].conditionKpi !== '' || this.data.conditions[3].conditionOperator !== '' || this.data.conditions[3].conditionValue !== '') {
                    // 条件4--其中有一个有值
                      this.$message.warning('请填写if前置条件！')
                    } else if (this.data.conditions[3].connector === '' && this.data.conditions[3].conditionKpi === '' && this.data.conditions[3].conditionOperator === '' && this.data.conditions[3].conditionValue === '') {
                    // 条件4--都没值
                    // 判断系数
                      if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                        this.row.kpiAchCondition = this.data
                        this.visible = false
                      } else {
                        this.$message.warning('请选择系数！')
                      }
                    }
                  }
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  if (this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '' || this.data.conditions[2].conditionValue !== '') {
                    // 条件3--其中有一个有值
                    this.$message.warning('请填写if前置条件！')
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                    // 条件3--都没值
                    if (this.data.conditions[3].connector !== '' || this.data.conditions[3].conditionKpi !== '' || this.data.conditions[3].conditionOperator !== '' || this.data.conditions[3].conditionValue !== '') {
                    // 条件4--其中有一个有值
                      this.$message.warning('请填写if前置条件！')
                    } else if (this.data.conditions[3].connector === '' && this.data.conditions[3].conditionKpi === '' && this.data.conditions[3].conditionOperator === '' && this.data.conditions[3].conditionValue === '') {
                    // 条件4--都没值
                    // 判断系数
                      if ((this.data.thenValue1 !== '' || this.data.thenValue2 !== '') && (this.data.endValue1 !== '' || this.data.endValue2 !== '')) {
                      // 系数--都有值
                        this.row.kpiAchCondition = this.data
                        this.visible = false
                      } else {
                        this.$message.warning('请选择系数！')
                      }
                    }
                  }
                }
              } else if (this.data.conditions[0].conditionKpi === '' && this.data.conditions[0].conditionOperator === '' && this.data.conditions[0].conditionValue === '') {
                // 条件1满足--都没值
                if (this.data.conditions[1].connector !== '' || this.data.conditions[1].conditionKpi !== '' || this.data.conditions[1].conditionOperator !== '' || this.data.conditions[1].conditionValue !== '') {
                  // 条件2--其中有一个有值
                  this.$message.warning('请填写if前置条件！')
                } else if (this.data.conditions[1].connector === '' && this.data.conditions[1].conditionKpi === '' && this.data.conditions[1].conditionOperator === '' && this.data.conditions[1].conditionValue === '') {
                  // 条件2--都没值
                  if (this.data.conditions[2].connector !== '' || this.data.conditions[2].conditionKpi !== '' || this.data.conditions[2].conditionOperator !== '' || this.data.conditions[2].conditionValue !== '') {
                    // 条件3--其中有一个有值
                    this.$message.warning('请填写if前置条件！')
                  } else if (this.data.conditions[2].connector === '' && this.data.conditions[2].conditionKpi === '' && this.data.conditions[2].conditionOperator === '' && this.data.conditions[2].conditionValue === '') {
                    // 条件3--都没值
                    if (this.data.conditions[3].connector !== '' || this.data.conditions[3].conditionKpi !== '' || this.data.conditions[3].conditionOperator !== '' || this.data.conditions[3].conditionValue !== '') {
                    // 条件4--其中有一个有值
                      this.$message.warning('请填写if前置条件！')
                    } else if (this.data.conditions[3].connector === '' && this.data.conditions[3].conditionKpi === '' && this.data.conditions[3].conditionOperator === '' && this.data.conditions[3].conditionValue === '') {
                    // 条件4--都没值
                    // 判断系数
                      if (this.data.thenValue1 === '' && this.data.thenValue2 === '' && this.data.endValue1 === '' && this.data.endValue2 === '') {
                      // 系数--都没值
                        this.row.kpiAchCondition = this.data
                        this.visible = false
                      } else {
                        this.$message.warning('请选择if条件！')
                      }
                    }
                  }
                }
              }
            }
          }
        }
      } else if (this.type === 'view') {
        this.visible = false
      } else if (this.type === 'delete') {
        this.visible = false
        this.row.kpiAchCondition = null
      }
    },
    // 模板
    dataTemplate () {
      return {
        premiseConditionKpi: '',
        premiseConditionOperator: '',
        premiseConditionValue: '',
        connector0: '',
        premiseConditionKpi1: '',
        premiseConditionOperator1: '',
        premiseConditionValue1: '',
        conditions: [
          {
            connector: '',
            conditionKpi: '',
            conditionOperator: '',
            conditionValue: ''
          }
        ],
        selectedThenValue: '1',
        thenValueDisabled: 'false',
        thenValue1: '',
        thenValue2: '',
        selectedEndValue: '3',
        endValueDisabled: 'false',
        endValue1: '',
        endValue2: ''
      }
    },
    // 调整规则所选的KPI列表-不包括自身
    kpiQueryByChannelId (row) {
      // console.log(row)
      this.$http.get(this.API.kpiQueryByChannelId, { params: { channelId: row.channelId, year: row.year } }).then(res => {
        // console.log(res)
        let data = res.data
        if (data.code === 200 && data.data.length > 0) {
          let arr = data.data
          let selectKpiList = []
          let arr1 = arr.filter(ele => {
            return ele.kpiNm !== row.kpi && (ele.kpiType === '季度考核' || ele.kpiType === '门槛')
          })
          arr1.forEach(ele => {
            selectKpiList.push({
              label: ele.kpiNm,
              value: ele.kpiNm
            })
          })
          this.selectKpiList = selectKpiList
        } else if (data.data.length === 0 || data.data === null) {
          this.$message.warning('暂无数据！')
        } else {
          this.$message.error('接口调用失败！')
        }
      })
    },
    // 起奖设定1提示
    tips1 () {
      // if (this.data.premiseConditionKpi === '' || this.data.premiseConditionOperator === '') {
      //   this.$message.warning('请选择起奖设定KPI或者运算符！')
      // }
    },
    // 起奖设定2提示
    tips2 () {
      // if (this.data.connector0 === '' || this.data.premiseConditionKpi1 === '' || this.data.premiseConditionOperator1 === '') {
      //   this.$message.warning('请选择起奖设定KPI或者运算符！')
      // }
    },
    // 系数条件提示
    tips3 () {
      // this.data.conditions.forEach((ele, i) => {
      //   if (i === 0) {
      //     if (ele.conditionKpi === '' || ele.conditionOperator === '') {
      //       this.$message.warning('请选择if条件KPI或者运算符！')
      //     }
      //   } else {
      //     if (ele.connector === '' || ele.conditionKpi === '' || ele.conditionOperator === '') {
      //       this.$message.warning('请选择if条件KPI或者运算符！')
      //     }
      //   }
      // })
    }
  }
}
</script>
<style lang="less" scoped>
.kpiRule {
  .conditionTitle {
    width:120px;
    text-align:center;
    font-size:16px;
    margin-bottom:22px;
    }
  .conditionLabel {
    width:120px;
    display:inline-block;
    text-align:center;
    font-size:16px;
  }
  .conditionSelect {
    padding: 0 10px;
    display: inline-block;
  }
  .conditionSelect1 {
    display: inline-block;
  }
  .w100 {
    width: 100px;
  }
  .conditionInput {
    padding:0 20px 0 10px;
    width:200px;
    display: inline-block;
  }
}

</style>
